<!--  -->
<div *ngIf="employeeTemplate.templateToOnboard">
    <div class="card" style=" overflow-x:hidden;  overflow-y:visible;height:800px;">
        <div class="mx-2">
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card">
                        <div class="card-header transparent">
                            <div class="text-end">
                                <button class="btn " (click)="saveEmployeeTemplate()">Save
                                </button>
                                <button class="btn ms-5" (click)="back()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden;   height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-2 text-center">
                                <h3><b>Employee Application Cover</b></h3>
                            </div>
                            <div class="row mt-4 col">
                                <div class="d-flex mt-3">
                                    <p class="ms-4 mt-1">Thank you for completing </p>
                                    <input id="scrollArea" class="form-control mx-1" style="width:30rem;" type="text"
                                       disabled >
                                    <p class="mt-lg-1"> Employee Application.</p>

                                </div>
                            </div>
                            <ul style="margin-left:30px">
                                <div class="row mt-4">
                                    <li>You are the applicant or employee in the following forms.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Please include a copy of your photo ID.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>The Department of Human Services (DHS) does not accept an electronic
                                        signature on
                                        their Individual Support Worker Application. DHS accepts a copy of the
                                        completed form.
                                        DHS refers to the applicant or employee as the Individual Direct Support
                                        Worker</li>
                                </div>
                                <div class="row mt-4">
                                    <li>You cannot be scheduled until you have cleared a background study which
                                        includes
                                        fingerprinting.<strong>{{global.agencyName}}</strong> pays for the cost of the study and
                                        fingerprinting can only be
                                        completed at an approved location. We notify your employer of your start
                                        date. We
                                        cannot pay hours before you are cleared to work by DHS.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Your employer will provide your pay rate and signs your Pay Notice.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Your employer will verify your ID’s for the Employment Eligibility
                                        Verification (I-9) and
                                        sign under the Employer section of that form.</li>
                                </div>
                                <div class="row mt-4">
                                    <li><strong>{{global.agencyName}}</strong> is your employer’s Fiscal/ Employer Agent (F/ EA).</li>

                                </div>

                            </ul>


                            <!-- </form> -->

                        </div>
                        <!-- <div class="col-12 mb-3 text-end">
                            <button class="btn" (click)="saveDocument()">Save</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <!--dis 1st -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden; height:auto;">
                        <div class="card-body" style="padding:35px;">
                            <div class="row mt-2 mb-2 text-center">
                                <h3 class="ms-lg-1"><b>Background Study Authorization</b></h3>
                            </div>
                            <!-- <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label clas="ms-lg-1">Participant/Employer
                                         
    
                                    </label>
                                </div>
                                <div class="col-lg-3">
                                      <input        type="text"  [(ngModel)]="documentBO.backgroound_Study_Authorization.employer_name"
                                        class="form-control">
                                </div> -->
                            <!-- </div> -->
                            <div class="col p-0">
                                <h6 class=""><b>Participant/Employer</b></h6>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label clas="ms-lg-1"> Participant Name
                                    </label>
                                    <input type="text" class="form-control" [(ngModel)]="backgroundBo.participantName" disabled>
                                </div>
                            </div>
                            <div class="row mt-2 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-body" style="padding:25px;">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="row">
                                                        <h6 class="ms-lg-1"><b>Applicant Information</b></h6>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">
                                                                First Name

                                                            </label>
                                                            <input type="text" class="form-control" disabled>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Middle Name</label>
                                                            <input type="text" class="form-control " disabled>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Last Name </label>
                                                            <input type="text" class="form-control " disabled>
                                                        </div>



                                                        <div class="col-lg-3 col-md-6 col-sm-6" >
                                                            <label class="label">Gender </label>
                                                           
                                                            <ng-select [items]="genderlist" 
                                                             bindValue="id"
                                                            bindLabel="lovName"  ></ng-select>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">
                                                                Date of Birth </label>
                                                            <my-date-picker class="w-100"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy" [disabled]="true">

                                                            </my-date-picker>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">SSN

                                                            </label>
                                                            <input (ngModelChange)="checkssn() " type="text" disabled
                                                                minlength="9" maxlength="9"
                                                                (keypress)="keyPress($event)" class="form-control">
                                                            <span class="ssn1" *ngIf="ssn4">{{ssnerror}}</span>
                                                        </div>





                                                        <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                                                            <label class="label">State</label>
                                                            <ng-select   [items]="stateList"  
                                                                [searchable]="true"
                                                                [(ngModel)]="Backgroound_Study_AuthorizationBO.state"
                                                                [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation">
                                                            </ng-select>
                                                        </div> -->
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Phone Number</label>
                                                            <input class=" form-control" type="text"
                                                                (keypress)="keyPress($event)" minlength="14"
                                                                maxlength="14" disabled>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Email

                                                            </label>
                                                            <input type="text" class="form-control" disabled>
                                                            <!-- <div *ngIf="offEmail.errors" [ngClass]="'error'"> -->

                                                            <!-- <div *ngIf="offEmail.errors.pattern">
                                                                    &nbsp;&nbsp;&nbsp; Email is not valid.
                                                                </div> -->
                                                            <!-- </div> -->
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Driver License</label>
                                                            <input class=" form-control" type="text" disabled>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 col-sm-6" >
                                                            <label class="label">State</label>
                                                           
                                                           

                                                            <ng-select  class="width25"  [items]="stateList" 
                                                            [searchable]="true" [clearable]="true" bindLabel="name"
                                                            bindValue="abbreviation"  [disabled]="true">
                                                        </ng-select>
                                                        </div>

                                                        <div class="col-lg-3  col-md-6 col-sm-6">
                                                            <label class="label">
                                                                Place of Birth</label>
                                                            <input class=" form-control" type="text" disabled>
                                                        </div>
                                                    </div>


                                                    <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Phone </label>
                                                              <input        type="number" class="form-control w-100" name="phone12"
                                                                maxlength="14" minlength="14"
                                                                [(ngModel)]="Backgroound_Study_AuthorizationBO.phone"
                                                                (ngModelChange)="DemographicPhoneFormat3()"
                                                                (keypress)="keyPress($event)" />
                                                        </div> -->

                                                    <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Driver License</label>
                                                              <input        class=" form-control" type="text"
                                                                [(ngModel)]="Backgroound_Study_AuthorizationBO.driver_LicenseNo"
                                                                (keypress)="keyPress($event)" minlength="14" maxlength="14">
                                                        </div> -->

                                                    <!-- </div> -->
                                                    <div class="row mt-2">
                                                        <label class="label "><b>Address</b> </label>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">street</label>
                                                            <input type="text" class="form-control" disabled>

                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">City</label>
                                                            <input type="text" class="form-control" disabled>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6" >
                                                            <label class="label">State</label>
                                                            <ng-select [items]="stateList"   
                                                                [searchable]="true" [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation" >
                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">ZipCode</label>
                                                            <input (ngModelChange)="validZip() " class="form-control"
                                                                minlength="5" maxlength="11"
                                                                (keypress)="keyPress($event)" disabled/>
                                                            <span class="ssn1" *ngIf="zip1">{{ziperr}}</span>

                                                        </div>
                                                    </div>
                                                    <div class="row">

                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">County</label>
                                                            <input type="text" class="form-control" disabled>
                                                        </div>

                                                        <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">
                                                                Place of Birth</label>
                                                            <my-date-picker   class="w-100" name="dob" id="dob"
                                                                [selDate]="Backgroound_Study_AuthorizationBO.place_of_birth"
                                                                (dateChanged)="newdates($event,'datechanged','POB_ngModelChange')"
                                                                (inputFieldChanged)="newdates($event,'inputchange','POB_input')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy">
                                                             </my-date-picker>
                                                        </div> -->


                                                    </div>


                                                    <!-- <div class="row mt-2">
                                                            <label class="label ms-lg-4 mt-lg-1"><b>Previous Names Used
                                                                </b></label>
                                                        </div> -->



                                                    <!-- <div class="row mt-2">
                                                            <label class="label ms-lg-4"><b>Previous Addresses Used (within
                                                                    the
                                                                    last 5
                                                                    years)</b></label>
                                                        </div> -->





                                                    <div class="row mt-2">
                                                        <label class="label ml-lg-4 mt-lg-1"><b>Previous Names Used
                                                            </b></label>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div class="col-lg-4">
                                                            <input type="text"
                                                                [(ngModel)]="backgroundBo.previousNamesUsed1"
                                                                class="form-control">
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class=" col-lg-4 label mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previousNamesUsedDate1"
                                                                [options]="myDatePickerOptions"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date')"
                                                                 (dateChanged)="newdates($event,'datechanged','date')"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-1">
                                                        <div class="col-lg-4">
                                                            <input type="text"  [(ngModel)]="backgroundBo.previousNamesUsed2" class="form-control">
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class=" col-lg-4 label mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previousNamesUsedDate2"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date1')"
                                                                 (dateChanged)="newdates($event,'datechanged','date1')"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <label class="label ml-lg-4"><b>Previous Addresses Used (within
                                                                the
                                                                last 5
                                                                years)</b></label>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used1"
                                                                class="form-control"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate1"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date2')"
                                                                 (dateChanged)="newdates($event,'datechanged','date2')"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-2">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used2"
                                                                class="form-control"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate2"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date3')"
                                                                 (dateChanged)="newdates($event,'datechanged','date3')"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-2">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used3"
                                                                class="form-control"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate3"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date4')"
                                                                 (dateChanged)="newdates($event,'datechanged','date4')"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>




                                                    <div class="row mt-4 ms-2">
                                                        <p>By signing this authorization, I give <strong>{{global.agencyName}}</strong>
                                                            permission to submit a background study request
                                                            to DHS as part of my application as a direct support
                                                            worker on a self-direction program. I verify
                                                            that the information provided is accurate and
                                                            complete. The following checks will be run: </p>
                                                    </div>
                                                    <ul style="margin-left: 30px;">
                                                        <li>MN DHS NetStudy 2.0 Background Study</li>
                                                        <li>Office of Inspector General Exclusions Database</li>
                                                    </ul>
                                                    <div class="row mt-4">
                                                        <div class="col-lg-8">
                                                            <div class="row">
                                                                <div class="col-lg-7">
                                                                    <button type="button" class="btn blue-btn"
                                                                        data-toggle="modal"
                                                                        data-target="#authsign" disabled>Applicant
                                                                        Signature</button>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div class="col-lg-3">
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label for="cname">Date
                                                                    </label>
                                                                </div>
                                                                <div class="col-lg-7">
                                                                    <my-date-picker class="w-100"
                                                                        [options]="myDatePickerOptions"
                                                                        placeholder="mm/dd/yyyy" [disabled]="true">


                                                                        <!-- (dateChanged)="newdates($event,'datechanged','authsigndate')"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','authsigndate')" -->
                                                                    </my-date-picker>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-4">
                                                            <input *ngIf="appsign1!=''&& appsign1!=null " type="image"
                                                                src="{{appsign1}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>





                                                    </div>



                                                    <div class="row mt-4 ms-2">
                                                        *If Applicant is under 18, the parent/guardian must sign
                                                        as well
                                                    </div>
                                                    <div class="row mt-4">
                                                        <div class="col-lg-8">
                                                            <div class="row">
                                                                <div class="col-lg-7">
                                                                    <button type="button" class="btn blue-btn"
                                                                        data-toggle="modal" disabled
                                                                        data-target="#parentsign">Parent/Guardian
                                                                        Signature</button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label for="cname">Date</label>
                                                                </div>
                                                                <div class="col-lg-7">
                                                                    <my-date-picker class="w-100"
                                                                        [options]="myDatePickerOptions"
                                                                        placeholder="mm/dd/yyyy" [disabled]="true">

                                                                    </my-date-picker>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-4">
                                                            <input *ngIf="sign4!=''&& sign4!=null " type="image"
                                                                src="{{sign4}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>





                                                    </div>

                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!--     
                                <div class="col-12  mb-3 mt-1 row justify-content-end">
                                    <div class="me-2">
                                        <button class="btn text-end" >Clear</button>
                                    </div>
    
    
                                    <div class="text-end">
                                        <button class="btn" (click)="saveDocument()">Save</button>
                                    </div>
                                </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <!--dis  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden;
                                      
                                        height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-3 mb-2 text-center">
                                <h3><b>Pay Notice</b></h3>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>
                                        Employee Name
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" disabled>
                                </div>
                                <div class="col-lg-2">
                                    <label>Employer Name
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" disabled>
                                </div>
                            </div>
                            <!-- <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>
                                        Effective Date
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <my-date-picker
                                        
                                        class="w-100" [selDate]="documentBO.paynotice.effective_date"
                                        (dateChanged)="newdates($event,'datechanged','payeffdate')"
                                        (inputFieldChanged)="newdates($event,'inputchange','payeffdate')"
                                        [options]="myDatePickerOptions" placeholder="mm/dd/yyyy">
                                         
                                    </my-date-picker>
                                </div>
                                <div class="col-lg-2">
                                    <label>Rate(s) </label>
                                </div>
                                <div class="col-lg-4">
                                    <input    
                                        
                                        type="text" [(ngModel)]="documentBO.paynotice.rate" class="form-control">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>Service(s)</label>
                                </div>
                                <div class="col-lg-4">
                                    <input    
                                        
                                        type="text" [(ngModel)]="documentBO.paynotice.service" class="form-control">
                                </div>
                            </div> -->

                            <div class="mt-3">
                                <table class="table-bordered">
                                    <tr style="height:30px;">
                                        <th style="width:5%">Effective Date</th>
                                        <th style="width:15%">Service</th>
                                        <th style="width:20%">Pay Rate</th>
                                    </tr>
                                    <tr style="height:25px;" *ngFor="let val of payRateList;let i = index">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </table>
                            </div>

                            <div class="row mt-2">
                                <p><b>Employee is non exempt (entitled to overtime, minimum wage, other
                                        protections under Minn.
                                        Stat. 177).</b></p>
                            </div>
                            <div class="row mt-2">
                                <p> Overtime is paid at 1.5 times the regular rate for hours worked over 40 per
                                    workweek</p>
                            </div>
                            <div class="row mt-2">
                                <p>The Collective Bargaining Agreement (SEIU/DHS) sets minimum wage, rules for
                                    Paid Time Off
                                    (PTO) accrual and designates Holiday pay:</p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>1 hour of PTO is earned for every 30 hours worked and accrued per pay period
                                    unless
                                    PTO is declined.</li>
                                <li>Hours worked on the following Holidays are paid at 1.5 times the regular pay
                                    rate: New
                                    Year’s Day, Dr. Martin Luther King Jr. Day, Memorial Day, Labor Day, and
                                    Thanksgiving</li>
                                <li>Employees choose 2 Floating Holidays per year. Hours worked on these days
                                    are paid at
                                    1.5 times the regular rate</li>
                            </ul>
                            <div class="row mt-2">
                                <p>Sick and safe leave may apply for employees in Duluth, Minneapolis and St
                                    Paul. City Sick and
                                    Safe Time (SST) rules are available in the Employee Handbook.</p>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Pay is issued every other Friday for a 14-day pay period, if time is
                                    submitted according to <strong>{{global.agencyName}}</strong>’s payroll calendar.
                                </p>
                            </div>
                            <div class="row mt-2">
                                <p>Deductions that may be made from employee’s pay include:</p>
                            </div>
                            <ul style="margin-left:30px;">
                                <li>FICA (Social Security/Medicare)</li>
                                <li>
                                    Federal/State Income Withholding Taxes

                                </li>
                                <li>
                                    Garnishments/Wage Attachments/Union Deductions (if applicable, as required
                                    by law)
                                </li>
                            </ul>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-toggle="modal"
                                                data-target="#epe" disabled>Employee Signature</button>

                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7">
                                            <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                placeholder="mm/dd/yyyy" [disabled]="true">

                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>


                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="Gurdsign3!=''&& Gurdsign3!=null " type="image" src="{{Gurdsign3}}"
                                        class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                        height="48">
                                </div>





                            </div>

                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-toggle="modal"
                                                data-target="#emp_signature" [disabled]="true">Employer 
                                                Signature</button>

                                        </div>

                                    </div>

                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7">
                                            <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                placeholder="mm/dd/yyyy" [disabled]="true">

                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="employeesign2!=''&& employeesign2 !=null " type="image"
                                        src="{{employeesign2}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>

                                <!-- </form> -->


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- dis -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden; height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-3 mb-2 text-center">
                                <h3><b>Relationship Disclosure</b></h3>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>
                                        Applicant Name

                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" disabled>
                                </div>
                                <div class="col-lg-2">
                                    <label>Applicant DOB

                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                        placeholder="mm/dd/yyyy" [disabled]="true">

                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Employer (EIN Holder) Name

                                    </label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" disabled>
                                </div>
                            </div>
                            <div class="row mt-2">
                                Employees providing household services may be exempt from paying certain federal
                                and state
                                taxes. If the employee qualifies, the exemptions must be applied.
                            </div>
                            <div class="row mt-2">
                                <p><b>Please check relationship to Employer (FEIN Holder): </b></p>
                            </div>
                            <div class="d-flex col-5 my-3">
                                <label class="me-4 fs-5"><b>Relationship</b></label>
                                <input class="form-control ps-3" type="text" disabled>
 
                             </div>
                            <!-- <div class="row mt-2">
                                <table class="table-bordered table-responsive">
                                    <tr>
                                       
                                        <th style="width:20%">S.No
                                           </th>
                                        <th style="width:20%">Tax</th>
                                        <th style="width:20%">Taxable</th>
        
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Spouse</td>
                                        <td>Exempt</td>                                
                                    </tr> 

                                </table>
                            </div> -->
                            <div class="row mt-2">
                                <p>*According to IRS definition, parent is typically defined here as biological
                                    or adoptive. A stepparent is not necessarily considered
                                    a parent for the purposes of exemptions listed. The CFSS Coordinator will
                                    verify exemption with additional questions as needed.</p>
                            </div>
                            <div class="row mt-2">
                                <p>** Minors include siblings and must be students. Federal and state labor
                                    restrictions are in place for hours a minor can work and
                                    job duties they can perform. <a
                                        href="https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf"
                                        target="_blank">https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf</a>
                                </p>
                            </div>
                            <div class="row mt-2">
                                <p>***General employees have no relationship to the employer or have a
                                    relationship that is not listed: child 21+, grandparents,
                                    sibling 18+, cousins, aunts, uncles, etc are general employees.</p>
                            </div>
                            <div class="row mt-2">
                                <p><b>Workers’ Compensation (WC) is required for employees except spouse,
                                        parent, or child of the
                                        employer</b>. Coverage is billed to the participant employer’s budget.
                                </p>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="spouse1" name="spouses"
                                        (ngModelChange)="work_allowed($event) " value="spose1" disabled>
                                </div>
                                <!--  
                                [ngModel]="documentBO.relationship_Disclosure.want_worker"-->
                                <div class="col-lg-10">
                                    I am a spouse, parent, or child of the employer and want Workers’
                                    Compensation coverage
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="spouse2" name="spouses"
                                        (ngModelChange)="work_allowed($event) " value="spose2" disabled>
                                    <!-- [ngModel]="documentBO.relationship_Disclosure.decline_worker" -->
                                </div>
                                <div class="col-lg-10">
                                    I am a spouse, parent, or child of the employer and decline Workers’
                                    Compensation coverage.
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-toggle="modal"
                                                data-target="#app_signature" disabled>Applicant 
                                                Signature</button >

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7">
                                            <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                placeholder="mm/dd/yyyy" [disabled]="true">


                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="clientsign0!=''&& clientsign0!=null " type="image"
                                        src="{{clientsign0}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>





                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-toggle="modal"
                                                data-target="#emp_signature2" disabled>Employer
                                                Signature</button>

                                        </div>

                                    </div>

                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date</label>
                                        </div>
                                        <div class="col-lg-7">
                                            <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                placeholder="mm/dd/yyyy" [disabled]="true">

                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="employeesign3!=''&& employeesign3!=null " type="image"
                                        src="{{employeesign3}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>




                            </div>
                            <!-- </form> -->

                        </div>
                    </div>
                </div>
            </div>
            <!-- dis -->

            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden;height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-2 mb-2 text-center">
                                <h3><b>Employee Agreement and Direct Deposit</b></h3>
                            </div>

                            <div class="row mt-4">
                                <p>I acknowledge that I have reviewed the Employee Handbook, including Mandated
                                    Reporting,
                                    Fraud, Roles and Responsibilities and HIPAA Data Privacy.</p>
                            </div>
                            <div class="row mt-2">
                                <p>I understand I am an employee of the participant employer. My employer is
                                    responsible for
                                    hiring, training, establishing job duties, scheduling, supervising, and
                                    evaluating my
                                    performance. The participant employer sets my pay rate within program
                                    guidelines. If I am
                                    scheduled to work by my employer beyond budgeted funds, <strong>{{global.agencyName}}</strong> CFSS
                                    will
                                    not pay. I
                                    understand that submitting time I did not work is fraud.</p>
                            </div>
                            <div class="row mt-2">
                            <strong>{{global.agencyName}}</strong> CFSS acts as the Fiscal/Employer Agent (F/EA) and is responsible
                                for
                                payroll, filing
                                taxes, and W-2s.<strong> {{global.agencyName}}</strong> CFSS uses CYMA for payroll processing. Pay
                                statements
                                and PTO
                                accrual are available through CYMA.
                            </div>
                            <div class="row mt-2">
                                I authorize <strong>{{global.agencyName}}</strong> CFSS to initiate automatic deposits to my account and
                                initiate debit
                                entries to my account for the purpose of correcting an erroneous amount
                                previously
                                deposited in my account. If the designated account is closed or has an
                                insufficient balance for
                                withdrawal, I authorize <strong>{{global.agencyName}}</strong> CFSS to withhold from payment owed to me by
                            <strong>{{global.agencyName}}</strong> CFSS
                                until the erroneous amount is repaid.

                            </div>
                            <div class="row mt-2">
                                <p><b>Please include a voided check or bank letter for direct deposit</b></p>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Routing #</label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="directdepositBo.routing">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Account #</label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="directdepositBo.account">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" [(ngModel)]="directdepositBo.checkingOrSaving" id="checking" name="savecheck" value="check">
                                    <!-- [(ngModel)]="directdepositBo.checkingOrSaving"> -->
                                    <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.checking_bool"> -->
                                </div>
                                <div class="col-lg-6">
                                    <label>Checking</label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" [(ngModel)]="directdepositBo.checkingOrSaving" id="saving" name="savecheck" value="save">
                                    <!-- [(ngModel)]="directdepositBo.checkingOrSaving"> -->
                                    <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.savings_bool"> -->
                                </div>
                                <div class="col-lg-6">
                                    <label> Savings</label>
                                </div>
                            </div>
                            <div class="row mt-2">
                            <strong>{{global.agencyName}}</strong> CFSS is not responsible for charges I incur from my financial
                                institution for writing
                                checks against my account before funds have been credited to my account.
                            </div>
                            <div class="row mt-2">
                                By signing this agreement, I verify that information I have provided is
                                accurate. <strong>{{global.agencyName}}</strong> uses
                                information on the Relationship Disclosure to set up the correct taxes for me
                                and if I have
                                submitted inaccurate information, I am liable for taxes owed.
                            </div>

                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Applicant Name </label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" disabled>
                                </div>
                            </div>

                            <div class="row mt-4 mb-3">
                                <div class="col-lg-6">
                                    <button type="button" class="btn btn-primary" data-toggle="modal"
                                        data-target="#deposit" disabled>
                                        Applicant Signature
                                    </button>

                                </div>

                            </div>
                            <div class="row mb-2">

                                <div class="col">
                                    <input *ngIf="clientsign2!=''&& clientsign2!=null " type="image"
                                        src="{{clientsign2}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">


                                </div>
                            </div>





                            <!-- </form> -->

                        </div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card" style="height:auto;">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body" style="padding: 45px;">
                                    <!-- <form [formGroup]="dh1form"> -->
                                    <div class="row mb-2">
                                        <div class="col-lg-12">
                                            <img src="..\assets\img\DHS_4469A.JPG" class="img-fluid"
                                                alt="Responsive image">

                                            <h3 class="mb-0" style="text-align: center;">
                                                <b>
                                                    Individual Direct Support Worker Enrollment Application
                                                    (Consumer Directed Community Supports [CDCS] and Consumer
                                                    Support Grant [CSG])



                                                </b>

                                            </h3>
                                            <p class="mb-2 mt-2">
                                                Complete all fields to enroll an individual direct support
                                                worker (DSW). Complete this form, print and then submit to
                                                Minnesota Health Care Programs (MHCP). An incomplete form will
                                                delay processing of this application. Check one of the
                                                following:
                                            </p>


                                        </div>

                                    </div>
                                    <div class=" ms-2">
                                        <div class="col-lg-5 d-flex">
                                            <!-- [value]="val.Key" -->
                                            <input type="radio" id="new_hire" name="hire" [(ngModel)]="directSupportWorker.newHireOrReHire"
                                                (ngModelChange)="hire($event) " value="newhire" >
                                                <!-- [(ngModel)]="directSupportWorker.newHireOrReHire" -->
                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.newHire" -->
                                            <label class=" mt-lg-2 ms-2">Newhire (requires new background study for CDCS
                                                only)</label>

                                        </div>

                                    </div>
                                    <!-- <div class=" ms-2">
                                        <div class="col-lg-5 d flex" >
                                            <!-- [value]="val.Key"
                                              <input        type="radio" 
                                                [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.hireLid" name="hire">
                                            <label>Rehire (requires new background study for CDCS only)</label>
    
                                        </div>
    
                                    </div> -->
                                    <div class="row  mb-1 mt-1">
                                        <div class="col-lg-5 ms-2">
                                            <input type="radio" id="rehire" name="hire" (ngModelChange)="hire($event) " 
                                            
                                                value="rehire"  [(ngModel)]="directSupportWorker.newHireOrReHire">&nbsp;
                                                <!-- [(ngModel)]="directSupportWorker.newHireOrReHire" -->
                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.reHire" -->
                                            <label class="ms-1">Rehire (requires new background study for CDCS
                                                only)</label>

                                        </div>
                                        <div class="col-lg-3">
                                            <label>PREVIOUS EMPLOYMENT END DATE:</label>

                                        </div>
                                        <div class="col-lg-3">
                                            <my-date-picker class="w-100 text-end" [options]="myDatePickerOptions"
                                            [selDate]="directSupportWorker.previousEmployementEndDate"
                                            (inputFieldChanged)="newdates($event,'inputchange','date5')"
                                                                 (dateChanged)="newdates($event,'datechanged','date5')"
                                                placeholder="mm/dd/yyyy">

                                            </my-date-picker>


                                        </div>

                                    </div>

                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <b>
                                                        <h4>Individual DSW Information</h4>
                                                    </b>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>PROVIDER TYPE</label>
                                                            <input type="text" class="form-control" placeholder=""  disabled >


                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>SOCIAL SECURITY NUMBER
                                                                <!--   -->
                                                            </label>
                                                            <input (ngModelChange)="checkssn() " type="text"
                                                                minlength="9" maxlength="9" disabled
                                                                (keypress)="keyPress($event)" class="form-control">

                                                            <span class="ssn1" *ngIf="ssn">{{ssnerror}}</span>
                                                        </div>

                                                        <div class="col-lg-5">
                                                            <label>NPI OR UMPI (IF REQUESTING
                                                                REINSTATEMENT)
                                                                <!--   -->
                                                            </label>
                                                            <input maxlength="10" type="text" class="form-control" disabled>

                                                        </div>



                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>LEGAL NAME (FIRST)

                                                            </label>
                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()" disabled>

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>FULL MIDDLE NAME</label>
                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()" disabled>

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>LAST NAME</label>

                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()" disabled>

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>Date of Birth </label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [options]="myDatePickerOptions"
                                                                placeholder="mm/dd/yyyy" [disabled]="true">

                                                            </my-date-picker>



                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>Phone Number</label>
                                                            <input type="text" minlength="14" maxlength="14"
                                                                class="form-control" (keypress)="keyPress($event)" disabled>

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col d-flex">
                                                            If individual has been working in a different
                                                            support position or was enrolled for MCO claims
                                                            only, has the
                                                            individual been continuously employed by your
                                                            agency? &nbsp;&nbsp;Yes
                                                            <!-- <div class="ms-5" *ngFor="let val of yes_or_no_lst"> -->
                                                            <input type="radio" class="me-1" value="true" name="yes_1"  (change)="IDSWFormRadio1()"
                                                            [(ngModel)]="individualDirectSupportBoRadio1"
                                                            >
                                                            <!-- [(ngModel)]="directSupportWorker.isMcoClaimsOnly" -->
                                                            &nbsp; No
                                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.continuously_Employeed -->
                                                            <input type="radio" value="false" name="yes_1"         (change)="IDSWFormRadio1()"
                                                            [(ngModel)]="individualDirectSupportBoRadio1"
                                                           >
                                                           <!-- [(ngModel)]="directSupportWorker.isMcoClaimsOnly" -->
                                                            <!-- {{val.Value}} -->


                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <!-- </div> -->
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Background Study Information</b></h4>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <label>PROGRAM TYPE</label> 
                                                            <input type="text" class="form-control"  disabled>

                                                        </div>

                                                    </div>
                                                    <div class="row mt-2 mb-2">
                                                        <div class="col">

                                                            <table class="table table table-bordered">
                                                                <thead>

                                                                    <tr>
                                                                        <th>BGS number
                                                                            (required only for CDCS)</th>
                                                                        <th>
                                                                            Application number
                                                                        </th>
                                                                        <th>Facility ID </th>
                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="let table of DSwstudyBolist ; let i=index">
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.bsgNumber"
                                                                                class="form-control" disabled>
                                                                        </td>
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.applicationNumber" disabled
                                                                                class="form-control" >
                                                                        </td>
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.facilityId"
                                                                                class="form-control" disabled>
                                                                        </td>
                                                                        <td>
                                                                            <button class="butn" disabled
                                                                                (click)="clicktab(i,table)"
                                                                                *ngIf="table.isadd"> <i
                                                                                    class="fa fa-plus"
                                                                                    aria-hidden="true"></i></button>
                                                                            <button class="butnred"
                                                                                (click)="removeTab(i)"
                                                                                *ngIf="!table.isadd">
                                                                                <i class="fa fa-times"></i></button>

                                                                        </td>
                                                                    </tr>
                                                                    <!-- <tr>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                        <td> <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="backgroundInfoBo."
                                                                                class="form-control"></td>
                                                                    </tr> -->
                                                                </tbody>

                                                            </table>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <!-- disableddisabled -->
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Address</b></h4>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <label>STREET ADDRESS</label>
                                                            <textarea class="form-control"
                                                                placeholder="Residential address only - Do not enter PO Box" disabled></textarea>



                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-3">
                                                            <label>city</label>
                                                            <input type="text" class="form-control" placeholder="" disabled>

                                                        </div>
                                                        <div class="col-lg-3" >
                                                            <label>State</label>
                                                            <ng-select [items]="stateList" 
                                                                [searchable]="true" [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation" disabled>
                                                            </ng-select>

                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>Zip Code</label>
                                                            <input (ngModelChange)="validZip() " type="text"
                                                                minlength="5" maxlength="11"
                                                                (keypress)="keyPress($event)" class="form-control"
                                                                placeholder=" " disabled>
                                                            <span class="ssn1" *ngIf="zip2">{{ziperr}}</span>


                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>COUNTY OF RESIDENCE</label>
                                                            <input type="text" class="form-control" placeholder="" disabled>


                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Training Information</b></h4>
                                                    <div class="d-flex">
                                                        <div class="col-lg-5.5 mt-1">
                                                            <label>Did this worker take Qualified Enhanced Rate
                                                                training? (an optional training)</label>

                                                        </div>
                                                        <div class="col-lg-2 ms-3">

                                                            <div class="row">
                                                                <div class="ms-1 d-flex">
                                                                    <label class="me-1 mt-1">Yes</label>
                                                                    <input type="radio" class="me-1" name="rd"   (change)="IDSWFormRadio2()"
                                                                        value="true"  [(ngModel)]="individualDirectSupportBoRadio2">
                                                                    <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training"
                                                                        [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training" -->
                                                                    <label class="me-1 mt-1">No</label>
                                                                    <input type="radio" name="rd" (change)="IDSWFormRadio2()" value="false" [(ngModel)]="individualDirectSupportBoRadio2" >
                                                                    <!-- [(ngModel)]="directSupportWorker.isQualifiedEnhancedRateTraining" -->
                                                                    <!-- [(ngModel)]="directSupportWorker.isQualifiedEnhancedRateTraining" -->


                                                                </div>

                                                            </div>




                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label>OPTIONAL TRAINING COMPLETION DATE</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [options]="myDatePickerOptions"
                                                                [selDate]="directSupportWorker.optionalTrainingCompletionDate"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date6')"
                                                                 (dateChanged)="newdates($event,'datechanged','date6')"
                                                                placeholder="mm/dd/yyyy">

                                                            </my-date-picker>

                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label>OPTIONAL TRAINING EXPIRATION DATE (if
                                                                applicable)</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [options]="myDatePickerOptions"
                                                                [selDate]="directSupportWorker.optionalTrainingExpirationDate"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date7')"
                                                                 (dateChanged)="newdates($event,'datechanged','date7')"
                                                                placeholder="mm/dd/yyyy">
                                                            </my-date-picker>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Provider Statement</b></h4>
                                                    <div class="row">
                                                        <div class="col">
                                                            <p>
                                                                I have reviewed and certify the information
                                                                provided on this form is true and correct to the
                                                                best of my knowledge.
                                                                <b>I will notify MHCP Provider Eligibility and
                                                                    Compliance of any additions or ngModelChanges to
                                                                    the information.</b>
                                                                By signing this form, I acknowledge I have read
                                                                and understand the <a href="" target="_blank" class="disabled-link">Data
                                                                    Privacy
                                                                    Notice (DHS-6287) (PDF).</a> I also
                                                                authorize MHCP to use the information you
                                                                collect about me according to the Privacy
                                                                Notice.
                                                                Check if signing electronically:
                                                            </p>
                                                            <p>Check if signing electronically:</p>
                                                            <p> <input type="checkbox"  disabled>I
                                                                am signing this form electronically. My name as
                                                                typed in the signature field is my legally
                                                                binding signature. I
                                                                understand that my electronic signature has the
                                                                same legal effect and can be enforced in the
                                                                same way as a
                                                                handwritten signature. (Minnesota Statutes
                                                                325L.02(h), 325L.05 and 325L.08)</p>


                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-7">
                                                            <label>NAME OF INDIVIDUAL SUPPORT WORKER (PRINT OR
                                                                TYPE) </label>
                                                            <input type="text" class="form-control" disabled>

                                                        </div>



                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <div class="row">
                                                                <div class="col-lg-7">

                                                                    <button type="button" class="btn blue-btn"
                                                                        data-toggle="modal"
                                                                        data-target="#DHS_4469A_modal2" disabled>Support Worker
                                                                        Signature</button>

                                                                </div>


                                                            </div>

                                                        </div>

                                                        <div class="col-lg-5">
                                                            <label>DATE SIGNED</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [options]="myDatePickerOptions" [disabled]="true"
                                                                placeholder="mm/dd/yyyy" >

                                                            </my-date-picker>
                                                            <!--   -->



                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-5">
                                                            <input *ngIf="individualsign!=''&& individualsign!=null "
                                                                type="image" src="{{individualsign}}"
                                                                class="form-control" style="width: 255px;height:120px;"
                                                                width="48" height="48">

                                                        </div>

                                                    </div>
                                                    <br>


                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4>Organization Affiliation Information</h4>
                                                    <div class="row">
                                                        <div class="col ">
                                                            <p>
                                                                You may affiliate or enroll the individual DSW
                                                                named on this form with another Fiscal Support
                                                                Entity (FSE) or
                                                                Community First Service and Support (CFSS) agency or
                                                                location you directly own without completing
                                                                another application
                                                                and agreement. Do you want to affiliate this
                                                                individual DSW with any other agency or location
                                                                you own? <label class="me-1 ms-3">Yes</label>


                                                                <!-- <div class="ms-2">
                                                                dSW_with_AnyOther_Agency_OR_Location_You_Own
                                                                <div class=" row">
                                                               [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.dSW_with_AnyOther_Agency_OR_Location_You_Own"  
                                                                      [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.dSW_with_AnyOther_Agency_OR_Location_You_Own"
    
                                                                -->

                                                                <input class="mt-1" type="radio" class="me-1"  [(ngModel)]="individualDirectSupportBoRadio3"
                                                                (change)="IDSWFormRadio3()"
                                                                    value="true" name="yes_3" 
                                                                    >
                                                                    <!-- [(ngModel)]="directSupportWorker.isAffiliateIndividualDsw" -->
                                                                <label class="me-1 ms-2">No</label>
                                                                <input class="mt-1" type="radio" value="false"
                                                                [(ngModel)]="individualDirectSupportBoRadio3"
                                                                (change)="IDSWFormRadio3()"
                                                                    name="yes_3">
                                                                    <!-- [(ngModel)]="directSupportWorker.isAffiliateIndividualDsw" -->



                                                                <!-- </div>
    
                                                            </div> -->
                                                            </p>
                                                        </div>


                                                    </div>

                                                    <div class="row mt-2">
                                                        <div class="col mb-5">
                                                            <p>
                                                                Check if signing electronically:
                                                            </p>

                                                        </div>


                                                    </div>
                                                    <div class="row">
                                                        <div class="col d-inline-flex">
                                                            <input type="checkbox"  disabled [(ngModel)]="directSupportWorker.orgAffiliationInfoSignDeclaration">&nbsp;
                                                            <p>
                                                                I am signing this form electronically. My name
                                                                as typed in the signature field is my legally
                                                                binding signature. I
                                                                understand that my electronic signature has the
                                                                same legal effect and can be enforced in the
                                                                same way as a
                                                                handwritten signature. (Minnesota Statutes
                                                                325L.02(h), 325L.05 and 325L.08)
                                                            </p>

                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label>Organization name</label>
                                                            <input type="text" class="form-control" [(ngModel)]="global.agencyName">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>FACILITY NPI OR UMPI</label>
                                                            <input type="text" class="form-control" maxlength="10"
                                                            [(ngModel)]="directSupportWorker.facilityNpi">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>STUDY ID</label>
                                                            <input type="text" class="form-control" [(ngModel)]="directSupportWorker.studyId">

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION PERSONNEL COMPLETING FORM</label>
                                                            <input type="text" class="form-control" [(ngModel)]="directSupportWorker.orgPersonalCompletingForm">
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION
                                                                PERSONNEL SIGNATURE</label>
                                                            <input type="text" class="form-control"
                                                            [(ngModel)]="directSupportWorker.orgPersonalSign">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION FAX NUMBER</label>
                                                            <input type="text" class="form-control" maxlength="14"
                                                                     [(ngModel)]="directSupportWorker.orgPersonalFax"
                                                                     (keypress)="keyPress($event)"
                                                                (ngModelChange)="DemographicPhoneFormat()">

                                                        </div>

                                                    </div>
                                                    <!-- <div class="row mb-2 mt-2">
                                                        <div class="col-lg-9">
                                                            <div class="row">
                                                                <div class="col-lg-7">
    
                                                                    <button type="button" class="btn blue-btn"   
                                                                        data-toggle="modal"
                                                                        data-target="#DHS_4469A_modal1">ORGANIZATION
                                                                        PERSONNEL SIGNATURE:</button>
                                                                     
    
                                                                </div>
    
    
                                                            </div>
    
                                                        </div>
    
    
                                                    </div>
                                                    <div class="row mt-2">
    
                                                        <div class="col-lg-5">
                                                              <input        *ngIf="supportsign!=''&& supportsign!=null " type="image"
                                                                src="{{supportsign}}" class="form-control"
                                                                style="width: 255px;height:120px;" 
                                                                width="48" height="48">
    
                                                        </div>
    
                                                    </div> -->
                                                    <br>


                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <!-- <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4>Next Steps</h4>
                                                    <div class="row">
                                                        <div class="col">
                                                            <p>
                                                                Read, sign and date the Individual Support
                                                                Worker (CDCS, CSG, PCA, CFSS) Provider Agreement
                                                                (DHS-4611) (PDF), and
                                                                return it with this application.
                                                                Upload the application and agreement to the MPSE
                                                                portal or fax to 651-431-7465. MHCP will process
                                                                only complete requests.
                                                            </p>
    
                                                        </div>
    
                                                    </div>
    
                                                </div>
    
                                            </div>
    
                                        </div>
    
                                    </div> -->

                                    <!-- </form> -->


                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style="height:auto;">
                        <div class="card-body" style="padding:55px;">
                            <!-- <form [formGroup]="Document1"> -->
                            <div class="mt-2 mb-2 col-12 float-center">
                                <img src="..\assets\img\Capture.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <h5>MINNESOTA HEALTH CARE PROGRAMS (MHCP) </h5>
                            <h2 style="color: black;"><b>Individual Support Worker (CDCS, CSG, PCA, CFSS)
                                    Provider Agreement</b></h2>
                            <div class="row mt-3 ms-2">
                                <p>As a participating provider in Minnesota Health Care Programs (MHCP)
                                    administered by the Minnesota Department
                                    of Human Services (DHS), the provider agrees to:</p>
                            </div>
                            <div class="row ">
                                <div class="col">
                                    <ol type="A" class="ms-5">
                                        <li>Submit documentation to your affiliated agency that fully discloses
                                            the extent of services provided to
                                            individuals under these programs. The documentation must be legible
                                            and meet the requirements of Minnesota
                                            Statutes, section 256B.0659, subdivision 12 for all individual
                                            support workers in Consumer Directed Community
                                            Supports (CDCS), Consumer Support Grant (CSG), Personal Care
                                            Assistance (PCA), and Community First Services
                                            and Supports (CFSS) .</li>
                                        <li>Furnish DHS, the secretary of the U.S. Department of Health and
                                            Human Services (DHHS), or the Minnesota
                                            Medicaid Fraud Control Unit with such information as it may request
                                            regarding payments claimed for services
                                            provided under these programs.</li>
                                        <li>Comply with all federal and state statutes and rules relating to the
                                            delivery of services to individuals and to the
                                            submission of claims for such services.</li>
                                        <li>Accept as payment in full, amounts paid in accordance with schedules
                                            established by DHS, except where
                                            payment by the member has been authorized by DHS.</li>
                                        <li>Make full disclosure of any conviction(s) of program crimes as
                                            required by the Code of Federal Regulations, title
                                            42, section 455.106.</li>
                                        <li>Comply with all federal statutes, implementing regulations and
                                            guidance prohibiting discrimination on the
                                            basis of race, color, national origin, sex, age, religion and
                                            disability in any program or activity receiving federal
                                            financial assistance from DHHS; and to comply with the Minnesota
                                            Human Rights Act.</li>
                                        <li>Provide services to members of the same scope and quality as would
                                            be provided to the general public, within
                                            MHCP guidelines.</li>
                                        <li>. Comply with the provisions of any fully executed agreement or
                                            addendum required by DHS, which is
                                            incorporated herein by reference.</li>
                                        <li>Comply with the advance directive requirements as required by the
                                            Code of Federal Regulations, title 42,
                                            sections 489.100 and 417.436.</li>
                                        <li>Properly handle and safeguard protected information collected,
                                            created, used, maintained, or disclosed on
                                            behalf of DHS. For purposes of this agreement, “protected
                                            information” means data subject to any of the
                                            following laws:</li>
                                        <ol type="1" class="ms-5">
                                            <li>The Minnesota Government Data Practices Act (MGDPA), Minnesota
                                                Statutes, chapter 13, section 13.46
                                                ("welfare data");</li>
                                            <li>The Minnesota Health Records Act, sections 144.291 and 144.298;
                                            </li>
                                            <li>The Health Insurance Portability and Accountability Act
                                                (“HIPAA”), including but not limited to the
                                                requirements of the Privacy Rule and the Security Regulations,
                                                the Code of Federal Regulations, title 45, parts
                                                160 and 164, subparts A and E.</li>
                                            <li>Federal law and regulations that govern the use and disclosure
                                                of substance abuse treatment records, the
                                                United States Code, title 42, section 290dd-2 and the Code of
                                                Federal Regulations, title 42, sections 2.1 to
                                                2.67; and Electronic initials accepted.</li>
                                            <div class="row">
                                                <div class="col-lg-8 ">
                                                </div>
                                                <div class="col-lg-4">
                                                    <label for="DIRECT SUPPORT WORKER INITIALS">
                                                        DIRECT SUPPORT WORKER INITIALS

                                                    </label>
                                                    <input type="text" class="form-control"
                                                    [(ngModel)]="supportWorkerBo.directSupportWorkerInitial" disabled>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-8">
                                                    <label for="NAME OF SUPPORT WORKER">
                                                        NAME OF SUPPORT WORKER

                                                    </label>
                                                    <input type="text" (change)="suptwrkName() " disabled class="form-control"
                                                    >

                                                </div>
                                                <div class="col-lg-4">
                                                    <label for="UMPI">
                                                        UMPI

                                                    </label>
                                                    <input type="text" maxlength="10" class="form-control"
                                                    [(ngModel)]="supportWorkerBo.umpi" disabled>
                                                </div>

                                            </div>


                                            <li>Any other applicable state and federal statutes, rules, and
                                                regulations affecting the collection, storage, use
                                                and dissemination of private or confidential information.</li>
                                        </ol>
                                        <li>
                                            Comply with the laws described in section J. This includes the
                                            provider:
                                        </li>

                                        <ol type="1" class="ms-4">
                                            <li>Not using or further disclosing protected information created,
                                                collected, received, stored, used, maintained or disseminated in
                                                the course or performance of this agreement other than as
                                                necessary to perform its obligations under this Provider
                                                Agreement, or as required by law, either during the period of
                                                this agreement or after. See, respectively, the Code of Federal
                                                Regulations, title 45, sections 164.502(b) and 164.514(d), and
                                                Minnesota Statutes, 13.05 subdivision 3.</li>
                                            <li>Using appropriate administrative, physical, and technical
                                                safeguards to prevent use or disclosure of the protected
                                                information other than as provided for by this agreement and to
                                                ensure the confidentiality, integrity, and availability of any
                                                electronic protected health information (PHI) that it creates,
                                                receives, maintains, or transmits on behalf of DHS. The provider
                                                will not transmit PHI over the Internet or any other unsecure or
                                                open communications channel unless such information is encrypted
                                                or otherwise safeguarded using procedures no less stringent than
                                                those described in the Code of Federal Regulations, title 45,
                                                section 164.312. If the provider stores or maintains PHI in
                                                encrypted form, the provider shall, at DHS’ request, promptly
                                                provide DHS with the key or keys to decrypt such information.
                                                The provider shall not forward previously encrypted data to any
                                                other party, unless otherwise required by this agreement.</li>
                                            <li>Mitigating, to the extent practicable, any harmful effects known
                                                to the provider of a use, disclosure, or breach of security with
                                                respect to protected information by the provider in violation of
                                                this agreement.</li>
                                        </ol>
                                        <li>
                                            Agree that this agreement may be immediately terminated at the
                                            discretion of DHS if it determines that the
                                            provider has violated a material term of the agreement, including
                                            but not limited to, non-compliance by the
                                            provider with the HIPAA Privacy Rule and Security Standards. If
                                            termination is not feasible, DHS shall report the
                                            breach to the Secretary of DHHS.
                                            Upon termination of this agreement, all of the protected information
                                            provided by DHS to the provider, or
                                            created or received by the provider on behalf of DHS, that the
                                            provider still maintains in any form, including
                                            information that is in the hands of subcontractors or agents of the
                                            provider, shall be destroyed or returned to
                                            DHS, and the provider shall retain no copies of such information. If
                                            it is infeasible to return or destroy the
                                            information, the provider shall provide DHS notification of the
                                            conditions that make return or destruction
                                            infeasible, and shall extend the protections of this agreement to
                                            such information and limit further use and
                                            disclosure of such information to those purposes that make return or
                                            destruction infeasible, for as long as the
                                            provider maintains the information.
                                        </li>
                                        <li>
                                            Agree that any ambiguity in this agreement shall be resolved to
                                            permit DHS to comply with HIPAA, MDGPA, and
                                            other applicable state and federal statutes, rules, and regulations
                                            affecting the collection, storage, use and
                                            dissemination of private or confidential information and other state
                                            and federal laws and regulations.
                                        </li>

                                    </ol>
                                    <div class="row ms-4">
                                        <p>Upon signature, this Provider Agreement supersedes and replaces all
                                            former Provider Agreements the provider has
                                            with DHS.</p>
                                    </div>
                                    <div class="row ms-4">
                                        <p>
                                            An individual applicant must personally sign the Provider Agreement.
                                            Sign and date this form, initial page 1, and
                                            return both page 1 and page 2 of this agreement.
                                        </p>
                                    </div>
                                    <div class="row ms-4">
                                        <p>
                                            Check if signing electronically:
                                        </p>
                                    </div>
                                    <div class="row ms-5">
                                        <p>
                                            <span> <input type="checkbox" disabled [(ngModel)]="supportWorkerBo.signDeclaration" ></span>
                                            I am signing this form electronically. My name as typed in the
                                            signature field is my legally binding signature. I
                                            understand that my electronic signature has the same legal effect
                                            and can be enforced in the same way as a
                                            handwritten signature. (Minnesota Statutes 325L.02(h), 325L.05 and
                                            325L.08)
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8 ">
                                            <label>NAME OF SUPPORT WORKER (TYPE OR PRINT)</label>
                                            <input type="text" class="form-control" disabled>
                                        </div>
                                        <div class="col-lg-4">
                                            <label for="DIRECT SUPPORT WORKER INITIALS">
                                                TITLE
                                            </label>
                                            <input type="text" class="form-control" disabled >
                                     <!------[(ngModel)]="supportWorkerBo.title"-->

                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-3">
                                        <div class="col-lg-8">
                                            <button type="button" class="btn btn-primary" data-toggle="modal"
                                                data-target="#agepage_modal1" disabled>
                                                SIGNATURE OF SUPPORT WORKER
                                            </button>

                                        </div>
                                        <div class="col-lg-4">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label for="Date">Date</label>
                                                </div>
                                                <div class="col-lg-10">
                                                    <my-date-picker class="w-100" [options]="myDatePickerOptions" [disabled]="true"                                                  
                                                        placeholder="mm/dd/yyyy">
                                                    </my-date-picker>
                                                     <!-- [selDate]="supportWorkerBo.signDate"
                                                    (inputFieldChanged)="newdates($event,'inputchange','date8')"
                                                                 (dateChanged)="newdates($event,'datechanged','date8')" -->
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col-lg-5">
                                            <input *ngIf="repsign!=''&& repsign!=null " type="image" src="{{repsign}}"
                                                class="form-control" style="width: 255px;height:120px;" width="48"
                                                height="48">

                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <p>
                                            Keep a copy of the Provider Agreement for your files and upload the
                                            original form using the online <a
                                                href="https://mn.gov/dhs/partners-and-providers/policies-procedures/minnesota-health-care-programs/provider/mpse/"
                                                target="_blank">Minnesota
                                                Provider Screening and Enrollment (MPSE) portal</a> or fax to
                                            651-431-7465.
                                        </p>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <h2 style="text-align: center;"><b>Agreement Summary</b></h2>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <p>
                                                As an individual support worker, you are providing health care
                                                services to individuals. We require your enrollment in the
                                                Minnesota Health Care Programs (MHCP) and to be listed as the
                                                rendering provider on the claim so that you are represented as
                                                the person who provided the services. Knowing that a qualified
                                                individual provided the service ensures the safety of the people
                                                that the Minnesota Department of Human Services (DHS) serves. It
                                                also allows DHS to perform auditing and tracking of services
                                                which protects against double-billing and other types of fraud.
                                                Before enrollment is approved, MHCP must make certain that:
                                            </p>
                                            <ol type="1">
                                                <li>There is no legal or other reason why you shouldn’t provide
                                                    these services,</li>
                                                <li>You understand what is necessary to properly provide these
                                                    services, and</li>
                                                <li>You understand the need to protect the privacy of the people
                                                    you care for.</li>
                                            </ol>


                                            <p>
                                                To help ensure that each of these conditions is met, MHCP
                                                requires that you agree to the terms in the attached Provider
                                                Agreement. In general, this agreement requires that you:
                                            </p>

                                            <ol type="A">
                                                <li>Provide documents to your employer about the services you
                                                    provide.</li>
                                                <li>Provide documents to MHCP or other state and federal
                                                    agencies related to the services you provide, when
                                                    requested.</li>
                                                <li>Comply with federal and state laws about the services you
                                                    provide.</li>
                                                <li>Accept payment made to your employer as payment in full for
                                                    the services you provide. You cannot ask for nor accept
                                                    additional payment from the member.</li>
                                                <li>Disclose any criminal convictions you have related to
                                                    Medicare, Medicaid, or title XX services.</li>
                                                <li>Not discriminate against individuals because of their race,
                                                    color, national origin, sex, age, religion or disability
                                                    when you provide these services.</li>
                                                <li>Provide the same quality of service to persons receiving
                                                    public assistance as those who don’t receive such
                                                    assistance.</li>
                                            </ol>
                                        </div>
                                        <div class="col-lg-6">
                                            <ol type="A" start="8">
                                                <li>If you are enrolled to provide and bill for other services,
                                                    you must continue to follow the requirements of the
                                                    agreement you signed when you enrolled for those services.
                                                    The terms of that agreement are different than the terms in
                                                    the attached agreement.</li>
                                                <li>Comply with federal requirements about advance directives.
                                                    An advance directive is written instruction, such as a
                                                    living will, to give a patient control over medical
                                                    treatment decisions.</li>
                                                <li>Properly protect private information about the people to
                                                    whom you provide services, especially their health
                                                    information.</li>
                                                <li>Don’t disclose the private information of someone for whom
                                                    you provide services, unless it is needed for your work.
                                                    This includes not discussing someone’s private information
                                                    unless your job requires it. Also, ensure that the
                                                    information could not be accessed by someone who does not
                                                    have permission to see it. This includes not leaving
                                                    paperwork out where others can see it, and not sending
                                                    private information over the internet.</li>
                                                <li>Understand that this agreement may be canceled if you
                                                    violate its terms. If this agreement is canceled, you must
                                                    properly dispose of any private information you have about
                                                    the people you serve so that it is not discovered by someone
                                                    who does not have permission to see it.</li>
                                                <li>Understand that this agreement may be canceled if you
                                                    violate its terms. If this agreement is canceled, you must
                                                    properly dispose of any private information you have about
                                                    the people you serve so that it is not discovered by someone
                                                    who does not have permission to see it.</li>
                                            </ol>

                                            <p>
                                                This is a basic description of the terms of this agreement.
                                            </p>


                                            <p>
                                                By signing this agreement, you are agreeing to be legally bound
                                                by all of its terms. If you have questions about it, you should
                                                get answers to them before signing this agreement. If you need
                                                or want legal advice, you should contact your own attorney. For
                                                more information, call 651-431-2700.
                                            </p>



                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card" style="height:auto;">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body" style="padding: 45px;">
                                    <div class="row mb-2">
                                        <div class="col-lg-12">

                                            <div class="row text-center">
                                                <div class="col d-inline-flex justify-content-center">
                                                    <img src="..\assets\i9_form_image.JPG"
                                                        class="img-fluid mt-lg-n4 mb-lg-3" alt="Responsive image">
                                                    <div style="text-align: center;">
                                                        <h4>
                                                            Employment Eligibility Verification Department
                                                        </h4>
                                                        <h4>
                                                            Department of Homeland Security
                                                        </h4>
                                                        <p>
                                                            U.S.Citizenship and Immigration
                                                        </p>
                                                    </div>


                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <h4 style="text-align: center;">
                                                        USCIS
                                                        Form I-9

                                                    </h4>

                                                </div>

                                            </div>
                                           



                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        ►START HERE: Read instructions carefully
                                                                        before completing this form. The
                                                                        instructions must be available, either in
                                                                        paper or electronically, during completion
                                                                        of this form. Employers are liable for
                                                                        errors in the completion of this form.
                                                                    </b>


                                                                </p> <br>
                                                                <p>
                                                                    <b>
                                                                        ANTI-DISCRIMINATION NOTICE:
                                                                    </b> It is illegal to discriminate against
                                                                    work-authorized individuals. Employers CANNOT
                                                                    specify which document(s) an employee may
                                                                    present to establish employment authorization
                                                                    and identity. The refusal to hire or continue to
                                                                    employ an individual because the documentation
                                                                    presented has a future expiration date may also
                                                                    constitute illegal discrimination.


                                                                </p>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-2 mt-2 col-12 p-0">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row ">
                                                            <div class="col">
                                                                <p><b>Section 1. Employee Information and
                                                                        Attestation (Employees must complete and sign
                                                                        Section 1 of Form I-9 no late(rthan the first
                                                                        day of
                                                                        employment, but not before accepting a job
                                                                        offer.)
                                                                    </b></p>


                                                            </div>

                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-lg-3">
                                                                <label>Last Name (Family Name)</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>First Name (Given Name)</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Middle Initial</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Other Last Names Used (if any)</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>


                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-lg-3">
                                                                <label>Address(Street Number and Name)</label>
                                                                <textarea class="form-control" disabled></textarea>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Apt. Number</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>City or Town</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3" >
                                                                <label>State</label>
                                                                <ng-select [items]="stateList" 
                                                                    [searchable]="true" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation" disabled>
                                                                </ng-select>

                                                            </div>


                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-lg-3">
                                                                <label>ZipCode</label>
                                                                <input (ngModelChange)="validZip() " type="text"
                                                                    minlength="5" maxlength="11" class="form-control" disabled>
                                                                <span class="ssn1" *ngIf="zip3">{{ziperr}}</span>


                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Date of Birth </label>
                                                                <my-date-picker class="w-100"
                                                                    [options]="myDatePickerOptions"
                                                                    placeholder="mm/dd/yyyy" [disabled]="true">

                                                                </my-date-picker>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>U.S. Social Security Number</label>
                                                                <input (ngModelChange)="checkssn() " type="text"
                                                                    class="form-control" minlength="7" maxlength="7"
                                                                    (keypress)="keyPress($event)" minlength="9"
                                                                    maxlength="9" disabled>
                                                                <span class="ssn1" *ngIf="ssn1">{{ssnerror}}</span>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>
                                                                    Employee's E-mail Address
                                                                </label>
                                                                <input type="text" class="form-control" disabled>

                                                                <!-- <div *ngIf="offEmail.errors" [ngClass]="'error'">
    
    
    
                                                                        <div *ngIf="offEmail.errors.pattern">
    
                                                                            &nbsp;&nbsp;&nbsp; Email is not valid.
    
                                                                        </div>
    
                                                                    </div> -->
                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Employee's Telephone Number</label>
                                                                <input type="text" class="form-control" minlength="10"
                                                                    maxlength="14" (keypress)="keyPress($event)" disabled>


                                                            </div>


                                                        </div>
                                                        <div class="row mt-2 mb-2">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        I am aware that federal law provides for
                                                                        imprisonment and/or fines for false
                                                                        statements or use of false documents in
                                                                        connection with the completion of this form.
                                                                    </b>
                                                                </p>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        I attest, under penalty of perjury, that I
                                                                        am (check one of the following boxes):
                                                                    </b>
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <input type="radio" id="citizen1"
                                                                        name="stateofcitizen" value="ctn1"
                                                                        (change)="one_bool($event) " disabled> 1. A
                                                                    citizen of
                                                                    the United States

                                                                </p>
                                                                <p>
                                                                    <input type="radio" id="citizen2"
                                                                        name="stateofcitizen" value="ctn3"
                                                                        (change)="one_bool($event) " disabled> 2. A
                                                                    noncitizen
                                                                    national of the United States (See instructions)

                                                                </p>
                                                                <p>
                                                                    <!-- [(ngModel)]="documentBO.employement_Eligibility_Verification.employeeInformation.lawful_resisdent" -->
                                                                    <input type="radio" id="citizen3"
                                                                        name="stateofcitizen" value="ctn3"
                                                                        (change)="one_bool($event) "disabled> 3. A
                                                                    lawful
                                                                    permanent resident (Alien Registration
                                                                    Number/USCIS Number): <input id="citizen3"
                                                                        type="text" min="0" class="form-control"
                                                                        (keypress)="keyPress($event)" 
                                                                        style="width: 180px;display: inline-block;" disabled>
                                                                </p>
                                                                <p>

                                                                    <input type="radio" id="citizen4"
                                                                        name="stateofcitizen" value="ctn4"
                                                                        (change)="one_bool($event) " disabled>
                                                                    4. An alien authorized to work until (expiration
                                                                    date, if applicable, mm/dd/yyyy):
                                                                    <my-date-picker [options]="myDatePickerOptions"
                                                                        style="width: 180px;display: inline-block;"
                                                                        placeholder="mm/dd/yyyy" [disabled]="true" >
                                                                    </my-date-picker>
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-9">
                                                                <p>
                                                                    Aliens authorized to work must provide only one
                                                                    of the following document numbers to complete
                                                                    Form I-9:
                                                                    An Alien Registration Number/USCIS Number OR
                                                                    Form I-94 Admission Number OR Foreign Passport
                                                                    Number.
                                                                </p>


                                                            </div>


                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-9">
                                                                <div class="row mb-2">
                                                                    <div class="col-lg-6">
                                                                        <label> 1. Alien Registration Number/USCIS
                                                                            Number:</label>
                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <input type="text" class="form-control" disabled>
                                                                    </div>





                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col" style="text-align: center;" >
                                                                        <b> OR</b>

                                                                    </div>

                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col-lg-6">
                                                                        <label> 2. Form I-94 Admission
                                                                            Number:</label>
                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <input type="text" class="form-control" disabled>
                                                                    </div>





                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col" style="text-align: center;">
                                                                        <b> OR </b>

                                                                    </div>

                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col-lg-6">
                                                                        <label> 3. Foreign Passport Number:</label>
                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <input type="text" class="form-control" disabled >
                                                                    </div>





                                                                </div>
                                                                <div class="row mb-2 mt-2">
                                                                    <div class="col-lg-6">
                                                                        <label> County of Issuance:</label>
                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <input type="text" class="form-control" disabled>
                                                                    </div>





                                                                </div>










                                                            </div>

                                                            <div class="col-lg-3">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        QR CODE

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-5">
                                                            <div class="col-lg-7">
                                                                <div class="row mt-2">
                                                                    <div class="col-lg-7">
                                                                        <button class="btn blue-btn" data-toggle="modal"
                                                                            data-target="#signature_employee" disabled>Signature
                                                                            of Employee</button >



                                                                    </div>


                                                                </div>

                                                            </div>
                                                            <div class="col-lg-5">
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <label> Today's Date:
                                                                        </label>

                                                                    </div>
                                                                    <div class="col-lg-8">
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions"
                                                                            placeholder="mm/dd/yyyy" [disabled]="true">

                                                                        </my-date-picker>


                                                                    </div>

                                                                </div>
                                                            </div>


                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col">
                                                                <input *ngIf="employeesign!=''&& employeesign!=null "
                                                                    type="image" src="{{employeesign}}"
                                                                    class="form-control"
                                                                    style="width: 255px;height:120px;" width="48"
                                                                    height="48">

                                                            </div>

                                                        </div>

                                                        <br>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2 col-12 p-0">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        Preparer and/or Translator Certification
                                                                        (check one):
                                                                    </b>
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row ms-2">
                                                            <div class="col-lg-6">

                                                                <p>
                                                                    <input type="radio" value="checkone1"
                                                                        name="checking" id="one1" 
                                                                        (ngModelChange)="clickone($event)" disabled >
                                                                        <!-- [(ngModel)]="eligibilityBo.penaltyOfPerjury" -->
                                                                    <!-- [(ngModel)]="documentBO.employement_Eligibility_Verification.empPreparerORTranslator.i_did_not_use" -->
                                                                    I did not use a preparer or translator.
                                                                </p>


                                                            </div>
                                                            <div class="col-lg-6">

                                                                <p>
                                                                    <input type="radio" id="one2" value="true"
                                                                        name="checking" disabled
                                                                        (ngModelChange)="clickone($event) ">
                                                                        <!-- [(ngModel)]="eligibilityBo.penaltyOfPerjury" -->

                                                                    A preparer(s) and/or translator(s) assisted the
                                                                    employee in completing Section 1.
                                                                </p>


                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    (Fields below must be completed and signed when
                                                                    preparers and/or translators assist an employee
                                                                    in completing Section 1.)
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        I attest, under penalty of perjury, that I
                                                                        have assisted in the completion of Section 1
                                                                        of this form and that to the best of my
                                                                        knowledge the information is true and
                                                                        correct.
                                                                    </b>
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-lg-7">
                                                                <div class="row mt-2">
                                                                    <div class="col-lg-7">
                                                                        <button class="btn blue-btn" data-toggle="modal"
                                                                            data-target="#traslatorModal" disabled>Signature
                                                                            of Preparer or Translator</button>

                                                                    </div>


                                                                </div>

                                                            </div>
                                                            <div class="col-lg-5">
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <label> Today's Date:</label>
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions"
                                                                            [selDate]="eligibilityBo.signOfPreparerorTraslatorDate"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date9')"
                                                                            (dateChanged)="newdates($event,'datechanged','date9')"
                                                                            placeholder="mm/dd/yyyy">

                                                                        </my-date-picker>
                                                                    </div>


                                                                </div>
                                                            </div>


                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col">
                                                                <input
                                                                    *ngIf="translatorsign!=''&& translatorsign!=null "
                                                                    type="image" src="{{translatorsign}}"
                                                                    class="form-control"
                                                                    style="width: 255px;height:120px;" width="48"
                                                                    height="48">

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-6">
                                                                <label>Last Name (Family Name)</label>
                                                                <input type="text" class="form-control"
                                                                [(ngModel)]="eligibilityBo.preparerLastName">

                                                            </div>
                                                            <div class="col-lg-6">
                                                                <label>First Name (Given Name)</label>
                                                                <input type="text" class="form-control"
                                                                [(ngModel)]="eligibilityBo.preparerFirstName">

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-5">
                                                                <label>Address (Street Number and Name)</label>
                                                                <textarea class="form-control"
                                                                [(ngModel)]="eligibilityBo.preparerAddress"></textarea>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>City or Town</label>
                                                                <input type="text" class="form-control"
                                                                [(ngModel)]="eligibilityBo.preparerCity">

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>State</label>
                                                                <ng-select [items]="stateList"  
                                                                    [searchable]="true" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation"
                                                                    [(ngModel)]="eligibilityBo.preparerState">
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Zip code</label>
                                                                <input (ngModelChange)="validZip() " type="text"
                                                                    minlength="5" maxlength="11"
                                                                    [(ngModel)]="eligibilityBo.preparerZip"
                                                                    (keypress)="keyPress($event)" class="form-control">
                                                                <span class="ssn1" *ngIf="zip4">{{ziperr}}</span>


                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        Section 2. Employer or Authorized
                                                                        Representative Review and Verification

                                                                    </b>
                                                                </p>


                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    (Employers or their authorized representative
                                                                    must complete and sign Section 2 within 3
                                                                    business days of the employee's first day of
                                                                    employment. You
                                                                    must physically examine one document from List A
                                                                    OR a combination of one document from List B and
                                                                    one document from List C as listed on the "Lists
                                                                    of Acceptable Documents.")
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <h6>Employee Info from Section 1</h6>

                                                            </div>


                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">
                                                                <label>Last Name (Family Name) </label>
                                                                <input type="text" class="form-control" disabled>


                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>First Name (Given Name) </label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Middle Initial</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Citizenship/Immigration Status</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <b> <label>List A</label></b>
                                                            </div>
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-2">
                                                                        <!-- <h6><b>OR</b></h6> -->
                                                                        <b>
                                                                            <label>OR</label>
                                                                        </b>



                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <!-- <h6><b></b></h6> -->
                                                                        <b>
                                                                            <label>List B</label>
                                                                        </b>

                                                                    </div>
                                                                    <div class="col-lg-2">
                                                                        <!-- <h6><b>AND</b></h6> -->
                                                                        <b>
                                                                            <label>AND</label>
                                                                        </b>

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <!-- <h6><b>List C</b></h6> -->
                                                                        <b> <label>List C</label> </b>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>Identity and Employment Authorization</label>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>Identity</label>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>Employment Authorization</label>

                                                            </div>



                                                        </div>

                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>Document Title</label>
                                                                <input type="text" class="form-control"
                                                                [(ngModel)]="eligibilityBo.documentTitle">

                                                            </div>
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-6">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentTitle1">

                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentTitle2">

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>Issuing Authority</label>
                                                                <input type="text" class="form-control"
                                                                [(ngModel)]="eligibilityBo.issuingAuthority">

                                                            </div>
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-6">
                                                                        <label>Issuing Authority</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.issuingAuthority1">

                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <label>Issuing Authority</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.issuingAuthority2">

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>Document Number</label>
                                                                <input type="text" min="0" class="form-control"
                                                                [(ngModel)]="eligibilityBo.documentNumber">

                                                            </div>
                                                            
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-6">
                                                                        <label>Document Number</label>
                                                                        <input type="text" min="0" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentNumber1">

                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <label>Document Number</label>
                                                                        <input type="text" min="0" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentNumber2">

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                        <hr>
                                                        <div class="row">
                                                            <div class="col-lg-4 mb-2"
                                                                style="border-bottom:1px solid #848484">
                                                                <label>Expiration Date</label>
                                                                <my-date-picker class="w-100"
                                                                [selDate]="eligibilityBo.expirationDate"
                                                                    [options]="myDatePickerOptions"
                                                                    (inputFieldChanged)="newdates($event,'inputchange','date10')"
                                                                 (dateChanged)="newdates($event,'datechanged','date10')"
                                                                    placeholder="mm/dd/yyyy">
                                                                </my-date-picker>

                                                            </div>
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-6">
                                                                        <label>Expiration Date</label>
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions"
                                                                            placeholder="mm/dd/yyyy"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date11')"
                                                                 (dateChanged)="newdates($event,'datechanged','date11')"
                                                                            [selDate]="eligibilityBo.expirationDate1">
                                                                        </my-date-picker>

                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <label>Expiration Date</label>
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date12')"
                                                                 (dateChanged)="newdates($event,'datechanged','date12')"
                                                                            placeholder="mm/dd/yyyy"
                                                                            [selDate]="eligibilityBo.expirationDate2">
                                                                        </my-date-picker>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentTitle3">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Issuing Authority</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.issuingAuthority3">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Document Number</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentNumber3">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12 mb-2"
                                                                        style="border-bottom:1px solid #848484">
                                                                        <label>Expiration Date</label>
                                                                        <my-date-picker class="w-100"
                                                                        [selDate]="eligibilityBo.expirationDate3"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date13')"
                                                                 (dateChanged)="newdates($event,'datechanged','date13')"
                                                                            [options]="myDatePickerOptions"
                                                                            placeholder="mm/dd/yyyy">
                                                                        </my-date-picker>

                                                                    </div>

                                                                </div>
                                                                <!-- <hr> -->
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentTitle4">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Issuing Authority</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.issuingAuthority4">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Document Number</label>
                                                                        <input type="text" class="form-control"
                                                                        [(ngModel)]="eligibilityBo.documentNumber4">

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <label>Expiration Date</label>
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions"
                                                                            placeholder="mm/dd/yyyy"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date14')"
                                                                 (dateChanged)="newdates($event,'datechanged','date14')"
                                                                            [selDate]="eligibilityBo.expirationDate4">
                                                                        </my-date-picker>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            <div class="col-lg-8">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <table class="table">

                                                                            <tr>

                                                                                <td rowspan="6">
                                                                                    <textarea rows="30" cols="25"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="eligibilityBo.additionalInfo"
                                                                                        placeholder="Additional Information"></textarea>

                                                                                </td>
                                                                                <td rowspan="6">
                                                                                    <div class="card">
                                                                                        <div class="card-body">
                                                                                            <p>QR CODE -sections 2 & 3
                                                                                                <br>
                                                                                                Do not write in this
                                                                                                space
                                                                                            </p>

                                                                                        </div>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>

                                                                        </table>

                                                                        <!-- <div class="row">
                                                                                              <div class="col-lg-7">
                                                                                                
                                                                                              </div> 
                                                                                              <div class="col-lg-5">
                                                                                                <div class="row">
                                                                                                    <div class="col">
                                                                                                        <div class="card">
                                                                                                            <div class="card-body">
                                                                                                                QR Code
                
                                                                                                            </div>
                
                                                                                                        </div>
                
                                                                                                    </div>
                
                                                                                                </div>
                
                
                                                                                              </div> 
                                                                   
                
                
                
                                                                                           </div> -->

                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>



                                                        <div class="row mb-2 mt-2">
                                                            <div class="col">
                                                                <p>
                                                                    <b>
                                                                        Certification: I attest, under penalty of
                                                                        perjury, that (1) I have examined the
                                                                        document(s) presented by the above-named
                                                                        employee,
                                                                        (2) the above-listed document(s) appear to
                                                                        be genuine and to relate to the employee
                                                                        named, and (3) to the best of my knowledge
                                                                        the
                                                                        employee is authorized to work in the United
                                                                        States.
                                                                    </b>
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-5">
                                                                <b><label>The employee's first day of employment
                                                                        (mm/dd/yyyy):</label></b>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <my-date-picker class="w-100"
                                                                    [options]="myDatePickerOptions"
                                                                    placeholder="mm/dd/yyyy" [disabled]="true">

                                                                </my-date-picker>



                                                            </div>
                                                            <div class="2">
                                                                (See instructions for exemptions)
                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-5">
                                                            <div class="col-lg-7">
                                                                <div class="row mt-2">
                                                                    <div class="col-lg-7">
                                                                        <button class="btn blue-btn" data-toggle="modal"
                                                                            data-target="#authorizedModal" disabled>Signature
                                                                            of Employer or Authorized
                                                                            Representative</button>




                                                                    </div>


                                                                </div>

                                                            </div>
                                                            <div class="col-lg-5">
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <label> Today's Date:

                                                                        </label>

                                                                    </div>
                                                                    <div class="col-lg-8">
                                                                        <my-date-picker class="w-100"
                                                                            [options]="myDatePickerOptions" [disabled]="true"
                                                                            placeholder="mm/dd/yyyy">

                                                                        </my-date-picker>


                                                                    </div>

                                                                </div>
                                                            </div>





                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col">
                                                                <input
                                                                    *ngIf="authorizedsign!=''&& authorizedsign!=null "
                                                                    type="image" src="{{authorizedsign}}"
                                                                    class="form-control"
                                                                    style="width: 255px;height:120px;" width="48"
                                                                    height="48">

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-3">
                                                                <label>Title of Employer or Authorized
                                                                    Representative</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Last Name of Employer or Authorized
                                                                    Representative</label>
                                                                <input type="text" class="form-control" disabled>


                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>First Name of Employer or Authorized
                                                                    Representative</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-3 mt-lg-4">
                                                                <label>Employer's Business or Organization
                                                                    Name</label>
                                                                <input type="text" class="form-control" disabled>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <label>Employer's Business or Organization
                                                                    Address</label>
                                                                <textarea class="form-control" disabled></textarea>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>City or Town</label>
                                                                <input type="text" class="form-control" disabled>


                                                            </div>
                                                            <div class="col-lg-3" >
                                                                <label>State</label>
                                                                <ng-select [items]="stateList"  
                                                                    [searchable]="true" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation" >
                                                                </ng-select>

                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label>Zip Code</label>
                                                                <input (ngModelChange)="validZip() " type="text"
                                                                    minlength="5" maxlength="11"
                                                                    (keypress)="keyPress($event)" class="form-control" disabled>
                                                                <span class="ssn1" *ngIf="zip5">{{ziperr}}</span>


                                                            </div>

                                                        </div>


                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <p> <b>Section 3. Reverification and Rehires</b> (To be
                                                            completed and signed by employer or authorized
                                                            representative.)</p>
                                                        <div class="row">
                                                            <div class="col-lg-8">
                                                                <b>A.</b> <label>New Name (if applicable)</label>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <b>B.</b> <label>Date of Rehire (if
                                                                    applicable)</label>

                                                            </div>

                                                        </div>

                                                        <div class="row">
                                                            <div class="col-lg-8">
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <label>Last Name</label>
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Last Name" disabled>
                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <label>First Name</label>
                                                                        <input type="text" class="form-control"
                                                                            placeholder="First Name" disabled>
                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <label>Middle Name</label>
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Middle Initial" disabled>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-lg-4">
                                                                <label>Date</label>
                                                                <my-date-picker class="w-100"
                                                                    [options]="myDatePickerOptions"
                                                                    placeholder="mm/dd/yyyy" [disabled]="true">

                                                                </my-date-picker>

                                                            </div>
                                                            <!-- </div>
    
                                                        </div> -->
                                                            <div class="row ms-1">
                                                                <div class="col">
                                                                    <p><b>C.</b>If the employee's previous grant of
                                                                        employment authorization has expired, provide
                                                                        the information for the document or receipt that
                                                                        establishes
                                                                        continuing employment authorization in the space
                                                                        provided below.</p>

                                                                </div>

                                                            </div>
                                                            <div class="row ms-1">
                                                                <div class="col-lg-3">
                                                                    <label>Document Title</label>
                                                                    <input type="text" class="form-control" disabled>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>Document Number</label>
                                                                    <input type="text" class="form-control" disabled>

                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <label>Expiration Date (if any) (mm/dd/yyyy)</label>

                                                                    <my-date-picker class="w-100"
                                                                        [options]="myDatePickerOptions"
                                                                        placeholder="mm/dd/yyyy" [disabled]="true">
                                                                    </my-date-picker>
                                                                </div>



                                                            </div>
                                                            <div class="row ms-1">
                                                                <div class="col">
                                                                    <p><b>I attest, under penalty of perjury, that to
                                                                            the best of my knowledge, this employee is
                                                                            authorized to work in the United States, and
                                                                            if
                                                                            the employee presented document(s), the
                                                                            document(s) I have examined appear to be
                                                                            genuine and to relate to the individual.</b>
                                                                    </p>

                                                                </div>

                                                            </div>



                                                            <div class="row col-12 mb-2 mt-5">
                                                                <div class="col-lg-6">
                                                                    <div class="row mt-2">
                                                                        <div class="col-lg-12">
                                                                            <button class="btn blue-btn"
                                                                                data-toggle="modal"
                                                                                data-target="#authorizedRepModal" disabled>Signature
                                                                                of Employer or Authorized
                                                                                Representative</button>



                                                                        </div>


                                                                    </div>

                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <div class="row">
                                                                        <div class="col-lg-5 mt-1">
                                                                            <label> Today's Date:</label>
                                                                        </div>
                                                                        <div class="col-lg-7">
                                                                            <my-date-picker
                                                                                [options]="myDatePickerOptions"
                                                                                placeholder="mm/dd/yyyy" [disabled]="true">
                                                                            </my-date-picker>


                                                                        </div>

                                                                    </div>
                                                                </div>





                                                            </div>

                                                            <div class="row col-12">
                                                                <div class="col-lg-5 mb-2 mt-2">
                                                                    <div class="col">
                                                                        <input
                                                                            *ngIf="authorizedrepsign!=''&& authorizedrepsign!=null "
                                                                            type="image" src="{{authorizedrepsign}}"
                                                                            class="form-control"
                                                                            style="width: 255px;height:120px;"
                                                                            width="48" height="48">

                                                                    </div>

                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <label>Name of Employer or Authorized
                                                                        Representative</label>
                                                                    <input type="text" class="form-control" disabled>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            <div class="row mb-2 mt-2">
                                                <div class="col">
                                                    <div class="card">
                                                        <div class="card-body">

                                                            <h4 style="text-align: center;">LISTS OF ACCEPTABLE
                                                                DOCUMENTS
                                                                All documents must be UNEXPIRED
                                                            </h4>
                                                            <p style="text-align: center;">Employees may present one
                                                                selection from List A

                                                                or a combination of one selection from List B and one
                                                                selection from List C.</p>

                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <p><b>LIST A
                                                                            Documents that Establish
                                                                            Both Identity and
                                                                            Employment Authorization OR</b></p>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <p>
                                                                        <b>LIST B
                                                                            Documents that Establish
                                                                            Identity AND</b>
                                                                    </p>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <p>
                                                                        <b>
                                                                            LIST C
                                                                            Documents that Establish
                                                                            Employment Authorization
                                                                        </b>
                                                                    </p>
                                                                </div>


                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <ol type="1" class="ms-2">
                                                                        <li>
                                                                            U.S. Passport or U.S. Passport Card
                                                                        </li>
                                                                        <li>
                                                                            Permanent Resident Card or Alien
                                                                            Registration Receipt Card (Form I-551)
                                                                        </li>
                                                                        <li>
                                                                            Foreign passport that contains a
                                                                            temporary I-551 stamp or temporary

                                                                            I-551 printed notation on a machine-
                                                                            readable immigrant visa
                                                                        </li>
                                                                        <li>
                                                                            Employment Authorization Document
                                                                            that contains a photograph (Form
                                                                            I-766)
                                                                        </li>
                                                                        <li>

                                                                            For a nonimmigrant alien authorized
                                                                            to work for a specific employer
                                                                            because of his or her status:
                                                                            <ol type="a" class="ms-4">
                                                                                <li>Foreign passport; and</li>
                                                                                <li>Form I-94 or Form I-94A that has
                                                                                    the following:</li>
                                                                                <ol type="1" class="ms-2">
                                                                                    <li>The same name as the passport;
                                                                                        and</li>
                                                                                    <li>
                                                                                        An endorsement of the alien's
                                                                                        nonimmigrant status as long as
                                                                                        that period of endorsement has
                                                                                        not yet expired and the
                                                                                        proposed employment is not in
                                                                                        conflict with any restrictions
                                                                                        or
                                                                                        limitations identified on the
                                                                                        form.
                                                                                    </li>

                                                                                </ol>
                                                                            </ol>
                                                                        </li>
                                                                        <li>
                                                                            Passport from the Federated States
                                                                            of Micronesia (FSM) or the Republic
                                                                            of the Marshall Islands (RMI) with
                                                                            Form I-94 or Form I-94A indicating
                                                                            nonimmigrant admission under the
                                                                            Compact of Free Association Between
                                                                            the United States and the FSM or RMI
                                                                        </li>


                                                                    </ol>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <ol type="1" class="ms-2">
                                                                        <li>
                                                                            Driver's license or ID card issued by a
                                                                            State or outlying possession of the
                                                                            United States provided it contains a
                                                                            photograph or information such as
                                                                            name, date of birth, gender, height, eye
                                                                            color, and address
                                                                        </li>
                                                                        <li>
                                                                            ID card issued by federal, state or local
                                                                            government agencies or entities,
                                                                            provided it contains a photograph or
                                                                            information such as name, date of birth,
                                                                            gender, height, eye color, and address
                                                                        </li>
                                                                        <li>
                                                                            School ID card with a photograph
                                                                        </li>
                                                                        <li>
                                                                            Voter's registration card
                                                                        </li>
                                                                        <li>
                                                                            U.S. Military card or draft record
                                                                        </li>
                                                                        <li>
                                                                            Military dependent's ID card
                                                                        </li>
                                                                        <li>
                                                                            U.S. Coast Guard Merchant Mariner
                                                                            Card
                                                                        </li>
                                                                        <li>
                                                                            Native American tribal document
                                                                        </li>
                                                                        <li>
                                                                            Driver's license issued by a Canadian
                                                                            government authority
                                                                        </li>
                                                                        <b>
                                                                            For persons under age 18 who are
                                                                            unable to present a document
                                                                            listed above:
                                                                        </b>
                                                                        <li>
                                                                            School record or report card
                                                                        </li>
                                                                        <li>
                                                                            Clinic, doctor, or hospital record
                                                                        </li>
                                                                        <li>
                                                                            Day-care or nursery school record
                                                                        </li>

                                                                    </ol>


                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <ol type="1">
                                                                        <li>
                                                                            A Social Security Account Number
                                                                            card, unless the card includes one of
                                                                            the following restrictions:
                                                                        </li>
                                                                        <li>
                                                                            Certification of report of birth issued
                                                                            by the Department of State (Forms
                                                                            DS-1350, FS-545, FS-240)
                                                                        </li>
                                                                        <li>
                                                                            Original or certified copy of birth
                                                                            certificate issued by a State,
                                                                            county, municipal authority, or
                                                                            territory of the United States
                                                                            bearing an official seal
                                                                        </li>
                                                                        <li>
                                                                            Native American tribal document
                                                                        </li>
                                                                        <li>
                                                                            U.S. Citizen ID Card (Form I-197)
                                                                        </li>
                                                                        <li>
                                                                            Identification Card for Use of
                                                                            Resident Citizen in the United
                                                                            States (Form I-179)
                                                                        </li>
                                                                        <li>
                                                                            Employment authorization
                                                                            document issued by the
                                                                            Department of Homeland Security
                                                                        </li>

                                                                    </ol>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p style="text-align: center;">
                                                                        <b>
                                                                            Examples of many of these documents appear
                                                                            in the Handbook for Employers (M-274).<br>

                                                                            Refer to the instructions for more
                                                                            information about acceptable receipts.
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>




                                                        </div>

                                                    </div>

                                                </div>

                                            </div>




                                        </div>





                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>
            </div>
            <!---->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card" style=" overflow-x:hidden;  height:auto;">
                        <div class="card-body" style="padding:85px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mb-4">
                                <div class="col-lg-2">
                                    <h5>Form<h3><b>W-4</b></h3>
                                    </h5>
                                    <p>Department of the Treasury
                                        Internal Revenue Service </p>
                                </div>
                                <div class="col-lg-8">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <h4><b>Employee’s Withholding Certificate</b></h4>
                                            <p><b>(For use by employers, corporations, partnerships, trusts,
                                                    estates, churches,
                                                    government agencies, Indian tribal entities, certain
                                                    individuals, and others.)</b></p>
                                            <p>
                                                <b>
                                                    ▶ Complete Form W-4 so that your employer can withhold the
                                                    correct federal income tax from your pay
                                                </b>
                                            </p>
                                            <p><b>
                                                    ▶ Give Form W-4 to your employer
                                                </b></p>
                                            <p><b>
                                                    ▶ Your withholding is subject to review by the IRS.
                                                </b></p>

                                        </div>
                                    </div>

                                </div>
                                <div class="col-lg-2">
                                    <p>OMB No. 1545-0074</p>
                                    <h5><b>2022</b></h5>

                                </div>
                            </div>
                            <div class="row mb-2 mt-4">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row mt-3">
                                                <div class="col-lg-4">
                                                    <label>(a) First name and middle initial </label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>Last Name </label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>(b) Social security number </label>
                                                    <input (ngModelChange)="checkssn() " type="text" minlength="9"
                                                        maxlength="9" (keypress)="keyPress($event)"
                                                        class="form-control" disabled>
                                                    <span class="ssn1" *ngIf="ssn2">{{ssnerror}}</span>
                                                </div>


                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-6">
                                                    <label>Address </label>
                                                    <textarea class="form-control" disabled></textarea>
                                                    <label>City or town, state, and ZIP code</label>
                                                    <!--  <textarea  
                                                        [(ngModel)]="documentBO.employees_withholding_certificate.personalInformation.city"
                                                        class="form-control"></textarea> -->

                                                </div>
                                                <div class="col-lg-2">

                                                </div>
                                                <div class="col-lg-3">
                                                    <p>▶ Does your name match the
                                                        name on your social security
                                                        card? If not, to ensure you get
                                                        credit for your earnings, contact
                                                        SSA at 800-772-1213 or go to
                                                        www.ssa.gov.</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">
                                                    (c)
                                                </div>
                                                <div class="col-lg-1">
                                                    <input type="radio" name="status" value="single"
                                                        (ngModelChange)="checkValue_single1($event) " disabled>
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Single or Married filing separately</label>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">

                                                </div>
                                                <div class="col-lg-1">
                                                    <input type="radio" name="status" value="married"
                                                        (ngModelChange)="checkValue_single1($event)" disabled>
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Married filing jointly or Qualifying
                                                        widow(er)</label>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">
 
                                                    
                                                </div>

                                                <div class="col-lg-1">
                                                    <input type="radio" name="status" value="household"
                                                        (ngModelChange)="checkValue_single1($event) " disabled>
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Head of household (Check only if you’re unmarried and
                                                        pay more than half the costs of keeping up a home for
                                                        yourself and a qualifying individual.)</label>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2 ms-2">
                                <p>Complete Steps 2–4 ONLY if they apply to you; otherwise, skip to Step 5. See
                                    page 2 for more information on each step, who can
                                    claim exemption from withholding, when to use the estimator at
                                    www.irs.gov/W4App, and privacy</p>
                            </div>
                            <div class="row mb-2 mt-4">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 2:</b>&nbsp;<b>Multiple Jobs
                                                    or Spouse
                                                    Works</b></h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>Complete this step if you (1) hold more than one job at a
                                                    time, or (2) are married filing jointly and your spouse
                                                    also works. The correct amount of withholding depends on
                                                    income earned from all of these jobs.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Do only one of the following.</p>
                                                <ol type="a" style="margin-left: 30px;">
                                                    <li> Use the estimator at www.irs.gov/W4App for most
                                                        accurate withholding for this step (and Steps 3–4); or
                                                    </li>
                                                    <li> Use the Multiple Jobs Worksheet on page 3 and enter the
                                                        result in Step 4(c) below for roughly accurate
                                                        withholding; or</li>
                                                    <li>If there are only two jobs total, <!--you may check this
                                                        box.--> do the same on Form W-4 for the other job. This
                                                        option is accurate for jobs with similar pay; otherwise,
                                                        more tax than necessary may be withheld 
                                                        <!-- . . ▶ <input
                                                            type="checkbox"> -->
                                                    </li>
                                                </ol>
                                            </div>
                                            <div class="row mt-2">
                                                <p><b>TIP:</b> To be accurate, submit a 2022 Form W-4 for all
                                                    other jobs. If you (or your spouse) have self-employment
                                                    income, including as an independent contractor, use the
                                                    estimator.</p>

                                            </div>
                                            <div class="row mt-2">
                                                <p><b>Complete Steps 3–4(b) on Form W-4 for only ONE of these
                                                        jobs.</b> Leave those steps blank for the other jobs.
                                                    (Your withholding will
                                                    be most accurate if you complete Steps 3–4(b) on the Form
                                                    W-4 for the highest paying job.)</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step3:</b>&nbsp;<b>Claim
                                                    Dependents </b></h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>If your total income will be $200,000 or less ($400,000 or
                                                    less if married filing jointly):
                                                </p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Multiply the number of qualifying children under age 17 by
                                                    $2,000 ▶$ <input type="number" min="0" class="form-control" [(ngModel)]="withHoldBo.qualifyingChildrenUnder_AgeSeventeen"
                                                        style="width: 180px;display: inline-block;"></p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Multiply the number of other dependents by $500 . . . .
                                                    ▶$ <input type="number" min="0" maxlength="14" class="form-control"  [(ngModel)]="withHoldBo.otherDependents"
                                                        style="width: 180px;display: inline-block;"></p>
                                            </div>

                                            <div class="row mt-2">
                                                <p>Add the amounts above and enter the total here . . . . . . .
                                                    . . . . . . 3&nbsp;&nbsp;$ <input type="number" min="0"
                                                        class="form-control"  [(ngModel)]="withHoldBo.total"
                                                        style="width: 180px;display: inline-block;">
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step4:</b>&nbsp;(optional):
                                                Other
                                                Adjustments</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <ol type="a">
                                                    <li>
                                                        Other income (not from jobs). If you want tax withheld
                                                        for other income you
                                                        expect this year that won’t have withholding, enter the
                                                        amount of other income here.
                                                        This may include interest, dividends, and retirement
                                                        income . . . . . . . .4(a)&nbsp;&nbsp;$ <input type="number"
                                                            min="0" class="form-control"  [(ngModel)]="withHoldBo.otherIncome"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                    <li>
                                                        Deductions. If you expect to claim deductions other than
                                                        the standard deduction and
                                                        want to reduce your withholding, use the Deductions
                                                        Worksheet on page 3 and enter
                                                        the result here . . . . . . . . . . . . . . . . . . . .
                                                        . . .4(b)&nbsp;&nbsp;$ <input type="number" min="0"
                                                            class="form-control"  [(ngModel)]="withHoldBo.deductions"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                    <li>
                                                        Extra withholding. Enter any additional tax you want
                                                        withheld each pay period . .4(c)&nbsp;&nbsp;$ <input
                                                            type="number" min="0" class="form-control"  [(ngModel)]="withHoldBo.additionalTax"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step5:</b>&nbsp;Sign
                                                Here
                                            </h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>Under penalties of perjury, I declare that this certificate,
                                                    to the best of my knowledge and belief, is true, correct,
                                                    and complete</p>

                                            </div>
                                            <div class="row mt-5 ms-2">
                                                <div class="col-6">
                                                    <button type="button" class="btn btn-primary" data-toggle="modal"
                                                        data-target="#nurse" disabled>
                                                        Employee’s signature
                                                    </button>

                                                </div>

                                                <div class="col-lg-1">
                                                    <label for="cname">Date:</label>
                                                </div>
                                                <div class="col-lg-4">
                                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                        placeholder="mm/dd/yyyy" [disabled]="true">
                                                    </my-date-picker>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <p> (This form is not valid unless you sign it.)</p>
                                            </div>
                                            <div class="row mt-2 mb-2">

                                                <div class="col-lg-4">
                                                    <input *ngIf="Gurdsign!=''&& Gurdsign!=null " type="image"
                                                        src="{{Gurdsign}}" class="form-control"
                                                        style="width: 255px;height:120px;" alt="nurse" width="48"
                                                        height="48">
                                                </div>
                                            </div>


                                            <div class="row">
                                                <div class="col-lg-2">
                                                    Employers
                                                    Only

                                                </div>

                                                <div class="col-lg-3">
                                                    <label>Employer’s name and address</label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                                <div class="col-lg-3">
                                                    <label>First date of
                                                        employment</label>
                                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                        placeholder="mm/dd/yyyy" [disabled]="true">
                                                    </my-date-picker>
                                                    <!--   <input        type="text" [(ngModel)]="EmployeeswithholdingcertificateBO.sign.firstDateOfEmployeement" class="form-control"> -->
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>Employer identification
                                                        number (EIN)
                                                    </label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-4">
                                <div class="col-lg-6">
                                    <h4><b>General Instructions</b></h4>
                                    <p>Section references are to the Internal Revenue Code. </p>
                                    <h4><b>Future Developments</b></h4>
                                    <p>For the latest information about developments related to
                                        Form W-4, such as legislation enacted after it was published,
                                        go to www.irs.gov/FormW4.</p>
                                    <h4><b>Purpose of Form</b></h4>
                                    <p>Complete Form W-4 so that your employer can withhold the
                                        correct federal income tax from your pay. If too little is
                                        withheld, you will generally owe tax when you file your tax
                                        return and may owe a penalty. If too much is withheld, you
                                        will generally be due a refund. Complete a new Form W-4
                                        when Changes to your personal or financial situation would
                                        Change the entries on the form. For more information on
                                        withholding and when you must furnish a new Form W-4,
                                        see Pub. 505, Tax Withholding and Estimated Tax. </p>
                                    <p><b>Exemption from withholding.</b> You may claim exemption
                                        from withholding for 2022 if you meet both of the following
                                        conditions: you had no federal income tax liability in 2021
                                        and you expect to have no federal income tax liability in
                                        2022. You had no federal income tax liability in 2021 if (1)
                                        your total tax on line 24 on your 2021 Form 1040 or 1040-SR
                                        is zero (or less than the sum of lines 27a, 28, 29, and 30), or
                                        (2) you were not required to file a return because your
                                        income was below the filing threshold for your correct filing
                                        status. If you claim exemption, you will have no income tax
                                        withheld from your paycheck and may owe taxes and
                                        penalties when you file your 2022 tax return. To claim
                                        exemption from withholding, certify that you meet both of
                                        the conditions above by writing “Exempt” on Form W-4 in
                                        the space below Step 4(c). Then, complete Steps 1(a), 1(b),
                                        and 5. Do not complete any other steps. You will need to
                                        submit a new Form W-4 by February 15, 2023.</p>
                                    <p><b>Your privacy.</b> If you prefer to limit information provided in
                                        Steps 2 through 4, use the online estimator, which will also
                                        increase accuracy. </p>
                                    <p>As an alternative to the estimator: if you have concerns
                                        with Step 2(c), you may choose Step 2(b); if you have
                                        concerns with Step 4(a), you may enter an additional amount
                                        you want withheld per pay period in Step 4(c). If this is the
                                        only job in your household, you may instead check the box
                                        in Step 2(c), which will increase your withholding and
                                        significantly reduce your paycheck (often by thousands of
                                        dollars over the year).</p>
                                    <p><b>When to use the estimator.</b> Consider using the estimator at
                                        www.irs.gov/W4App if you:

                                    </p>
                                    <ul type="1" style="margin-left: 30px;">
                                        <li>Expect to work only part of the year;</li>
                                        <li>Have dividend or capital gain income, or are subject to
                                            additional taxes, such as Additional Medicare Tax;
                                        </li>
                                        <li>Have self-employment income (see below); or
                                        </li>
                                        <li>Prefer the most accurate withholding for multiple job
                                            situations</li>
                                    </ul>
                                    <p><b>Self-employment.</b> Generally, you will owe both income and
                                        self-employment taxes on any self-employment income you
                                        receive separate from the wages you receive as an
                                        employee. If you want to pay these taxes through
                                        withholding from your wages, use the estimator at
                                        www.irs.gov/W4App to figure the amount to have withheld.</p>
                                    <p>Nonresident alien. If you’re a nonresident alien, see Notice
                                        1392, Supplemental Form W-4 Instructions for Nonresident
                                        Aliens, before completing this form.</p>
                                    <p><b>Nonresident alien.</b> If you’re a nonresident alien, see Notice
                                        1392, Supplemental Form W-4 Instructions for Nonresident
                                        Aliens, before completing this form</p>
                                </div>
                                <div class="col-lg-6">
                                    <h4><b>Specific Instructions</b></h4>
                                    <p><b>Step 1(c).</b> Check your anticipated filing status. This will
                                        determine the standard deduction and tax rates used to
                                        compute your withholding</p>
                                    <p><b>Step 2.</b> Use this step if you (1) have more than one job at the
                                        same time, or (2) are married filing jointly and you and your
                                        spouse both work.</p>
                                    <p>Option (a) most accurately calculates the additional tax
                                        you need to have withheld, while option (b) does so with a
                                        little less accuracy. </p>
                                    <p>If you (and your spouse) have a total of only two jobs, you
                                        may instead check the box in option (c). The box must also
                                        be checked on the Form W-4 for the other job. If the box is
                                        checked, the standard deduction and tax brackets will be
                                        cut in half for each job to calculate withholding. This option
                                        is roughly accurate for jobs with similar pay; otherwise, more
                                        tax than necessary may be withheld, and this extra amount
                                        will be larger the greater the difference in pay is between the
                                        two jobs</p>
                                    <p>
                                        Multiple jobs. Complete Steps 3 through 4(b) on only
                                        one Form W-4. Withholding will be most accurate if
                                        you do this on the Form W-4 for the highest paying job</p>
                                    <p><b>step3</b> This step provides instructions for determining the
                                        amount of the child tax credit and the credit for other
                                        dependents that you may be able to claim when you file your
                                        tax return. To qualify for the child tax credit, the child must
                                        be under age 17 as of December 31, must be your
                                        dependent who generally lives with you for more than half
                                        the year, and must have the required social security number.
                                        You may be able to claim a credit for other dependents for
                                        whom a child tax credit can’t be claimed, such as an older
                                        child or a qualifying relative. For additional eligibility
                                        requirements for these credits, see Pub. 501, Dependents,
                                        Standard Deduction, and Filing Information. You can also
                                        include other tax credits for which you are eligible in this
                                        step, such as the foreign tax credit and the education tax
                                        credits. To do so, add an estimate of the amount for the year
                                        to your credits for dependents and enter the total amount in
                                        Step 3. Including these credits will increase your paycheck
                                        and reduce the amount of any refund you may receive when
                                        you file your tax return</p>
                                    <h4><b>Step 4 (optional).</b></h4>
                                    <p><b>Step 4(a).</b> Enter in this step the total of your other
                                        estimated income for the year, if any. You shouldn’t include
                                        income from any jobs or self-employment. If you complete
                                        Step 4(a), you likely won’t have to make estimated tax
                                        payments for that income. If you prefer to pay estimated tax
                                        rather than having tax on other income withheld from your
                                        paycheck, see Form 1040-ES, Estimated Tax for Individuals.
                                    </p>


                                    <p><b>Step 4(b).</b> Enter in this step the amount from the
                                        Deductions Worksheet, line 5, if you expect to claim
                                        deductions other than the basic standard deduction on your
                                        2022 tax return and want to reduce your withholding to
                                        account for these deductions. This includes both itemized
                                        deductions and other deductions such as for student loan
                                        interest and IRAs</p>


                                    <p><b>Step 4(c).</b> Enter in this step any additional tax you want
                                        withheld from your pay each pay period, including any
                                        amounts from the Multiple Jobs Worksheet, line 4. Entering
                                        an amount here will reduce your paycheck and will either
                                        increase your refund or reduce any amount of tax that you
                                        owe.</p>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 2(b)</b>&nbsp;—Multiple Jobs Worksheet (Keep for your
                                                records.)</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>If you choose the option in Step 2(b) on Form W-4, complete
                                                    this worksheet (which calculates the total extra tax for all
                                                    jobs) on only ONE
                                                    Form W-4. Withholding will be most accurate if you complete
                                                    the worksheet and enter the result on the Form W-4 for the
                                                    highest paying job.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Note: If more than one job has annual wages of more than
                                                    $120,000 or there are more than three jobs, see Pub. 505 for
                                                    additional
                                                    tables; or, you can use the online withholding estimator at
                                                    www.irs.gov/W4App.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <ol style="margin-left: 10px;" type="1">
                                                    <li>Two jobs. If you have two jobs or you’re married filing
                                                        jointly and you and your spouse each have one
                                                        job, find the amount from the appropriate table on page
                                                        4. Using the “Higher Paying Job” row and the
                                                        “Lower Paying Job” column, find the value at the
                                                        intersection of the two household salaries and enter
                                                        that value on line 1. Then, skip to line 3 . . . . . . .
                                                        . . . . . . . . . . . . . .&nbsp;&nbsp;1
                                                        &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                        [(ngModel)]="withHoldBo.multiJobsWorksheetFirstJobField"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>



                                                    <li>Three jobs. If you and/or your spouse have three jobs at
                                                        the same time, complete lines 2a, 2b, and
                                                        2c below. Otherwise, skip to line 3.</li>
                                                    <ol style="margin-left: 30px;" type="a">
                                                        <li>Find the amount from the appropriate table on page 4
                                                            using the annual wages from the highest
                                                            paying job in the “Higher Paying Job” row and the
                                                            annual wages for your next highest paying job
                                                            in the “Lower Paying Job” column. Find the value at
                                                            the intersection of the two household salaries
                                                            and enter that value on line 2a . . . . . . . . . .
                                                            . . . . . . . . . . . . .&nbsp;&nbsp;2a
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                            [(ngModel)]="withHoldBo.multiJobsWorksheetSecondjobField_a"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>Add the annual wages of the two highest paying jobs
                                                            from line 2a together and use the total as the
                                                            wages in the “Higher Paying Job” row and use the
                                                            annual wages for your third job in the “Lower
                                                            Paying Job” column to find the amount from the
                                                            appropriate table on page 4 and enter this amount
                                                            on line 2b . . . . . . . . . . . . . . . . . . . . .
                                                            . . . . . . . &nbsp;&nbsp;2b &nbsp;&nbsp;$ <input
                                                                type="text" class="form-control"
                                                                [(ngModel)]="withHoldBo.multiJobsWorksheetSecondjobField_b"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>

                                                        <li>Add the amounts from lines 2a and 2b and enter the
                                                            result on line 2c . . . . . . . . . .&nbsp;&nbsp;2c
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                            [(ngModel)]="withHoldBo.multiJobsWorksheetSecondjobField_c"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>

                                                    </ol>


                                                    <li> Enter the number of pay periods per year for the
                                                        highest paying job. For example, if that job pays
                                                        weekly, enter 52; if it pays every other week, enter 26;
                                                        if it pays monthly, enter 12, etc. . . . .
                                                        .&nbsp;&nbsp;3 &nbsp;&nbsp;$ <input type="text"
                                                            class="form-control" [(ngModel)]="withHoldBo.multiJobsWorksheetThirdHobField"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>



                                                    <li>Divide the annual amount on line 1 or line 2c by the
                                                        number of pay periods on line 3. Enter this
                                                        amount here and in Step 4(c) of Form W-4 for the highest
                                                        paying job (along with any other additional
                                                        amount you want withheld) . . . . . . . . . . . . . . .
                                                        . . . . . . . . . . &nbsp;&nbsp;4 &nbsp;&nbsp;$ <input
                                                            type="text" class="form-control" [(ngModel)]="withHoldBo.multiJobsWorksheetTourthJobField"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                </ol>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 4(b)</b>&nbsp;—Deductions Worksheet (Keep for your
                                                records.)</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">


                                            <div class="row mt-2">

                                                <ol type="1" style="margin-left:30px">
                                                    <li>Enter an estimate of your 2022 itemized deductions (from
                                                        Schedule A (Form 1040)). Such deductions
                                                        may include qualifying home mortgage interest,
                                                        charitable contributions, state and local taxes (up to
                                                        $10,000), and medical expenses in excess of 7.5% of your
                                                        income. . . . . . . . . &nbsp;&nbsp;1
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="withHoldBo.deductionfirstamout"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                    <li>Enter: <ul style="margin-left:30px">
                                                            <li>$25,900 if you’re married filing jointly or
                                                                qualifying widow(er)</li>
                                                            <li>$19,400 if you’re head of household</li>
                                                            <li>$12,950 if you’re single or married filing
                                                                separately. . . . . . . .
                                                                &nbsp;&nbsp;2&nbsp;&nbsp;$ <input type="number" min="0"
                                                                    class="form-control" [(ngModel)]="withHoldBo.deductionSecondamount"
                                                                    style="width: 180px;display: inline-block;">
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>If line 1 is greater than line 2, subtract line 2 from
                                                        line 1 and enter the result here. If line 2 is greater
                                                        than line 1, enter “-0-” . . . . . . . &nbsp;&nbsp;3
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="withHoldBo.deductionThirdamount"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                    <li>Enter an estimate of your student loan interest,
                                                        deductible IRA contributions, and certain other
                                                        adjustments (from Part II of Schedule 1 (Form 1040)).
                                                        See Pub. 505 for more information . . . .&nbsp;&nbsp;4
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="withHoldBo.deductionFourthamount"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                    <li>Add
                                                        lines 3 and 4. Enter the result here and in Step 4(b) of
                                                        Form W-4 . . . . . . . . . &nbsp;&nbsp;5
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="withHoldBo.deductionFifthamount"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>

                                                </ol>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-3">
                                <div class="col-lg-6">
                                    <b>Privacy Act and Paperwork Reduction Act Notice</b>. We ask for the
                                    information
                                    on this form to carry out the Internal Revenue laws of the United States.
                                    Internal
                                    Revenue Code sections 3402(f)(2) and 6109 and their regulations require you
                                    to
                                    provide this information; your employer uses it to determine your federal
                                    income
                                    tax withholding. Failure to provide a properly completed form will result in
                                    your
                                    being treated as a single person with no other entries on the form;
                                    providing
                                    fraudulent information may subject you to penalties. Routine uses of this
                                    information include giving it to the Department of Justice for civil and
                                    criminal
                                    litigation; to cities, states, the District of Columbia, and U.S.
                                    commonwealths and
                                    possessions for use in administering their tax laws; and to the Department
                                    of
                                    Health and Human Services for use in the National Directory of New Hires. We
                                    may also disclose this information to other countries under a tax treaty, to
                                    federal
                                    and state agencies to enforce federal nontax criminal laws, or to federal
                                    law
                                    enforcement and intelligence agencies to combat terrorism
                                </div>
                                <div class="col-lg-6">
                                    You are not required to provide the information requested on a form that is
                                    subject to the Paperwork Reduction Act unless the form displays a valid OMB
                                    control number. Books or records relating to a form or its instructions must
                                    be
                                    retained as long as their contents may become material in the administration
                                    of
                                    any Internal Revenue law. Generally, tax returns and return information are
                                    confidential, as required by Code section 6103.
                                    The average time and expenses required to complete and file this form will
                                    vary
                                    depending on individual circumstances. For estimated averages, see the
                                    instructions for your income tax return.
                                    If you have suggestions for making this form simpler, we would be happy to
                                    hear
                                    from you. See the instructions for your income tax return.

                                </div>
                            </div>

                            <div class="row mt-4 mb-2">
                                <img src="..\assets\img\married.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <div class="row mt-2 mb-2">
                                <img src="..\assets\img\log.JPG" class="img-fluid" alt="Responsive image">
                            </div>



                            <!-- </form> -->
                            <!-- documentBO.employees_withholding_certificate.sign.date -->

                        </div>
                    </div>
                </div>
            </div>
            <!-- </div> -->
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card" style=" overflow-x:hidden;  height:auto;">
                        <div class="card-body" style="padding:85px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-4 mb-2">
                                <img src="..\assets\img\mahi.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <div class="row mt-2">
                                <p><b>complete Form W-4MN so that your employer can withhold the correct
                                        Minnesota income tax from your pay. Consider completing a new Form
                                        W-4MN each year and when your personal or financial situation
                                        Changes</b></p>
                            </div>

                            <div class="row mb-2 mt-4">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row mt-3">
                                                <div class="col-lg-4">
                                                    <label>(a) First name and middle initial
                                                    </label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>Last Name </label>
                                                    <input type="text" class="form-control" disabled>
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>(b) Social security number </label>
                                                    <input (ngModelChange)="checkssn() " type="text" minlength="9"
                                                        maxlength="9" (keypress)="keyPress($event)"
                                                        class="form-control" disabled>
                                                    <span class="ssn1" *ngIf="ssn3">{{ssnerror}}</span>
                                                </div>

                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-6">
                                                    <label>Permanent Address </label>
                                                    <textarea class="form-control" disabled></textarea>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label>City</label>
                                                            <input type="text" class="form-control" disabled>
                                                        </div>
                                                        <div class="col-lg-4" >
                                                            <label>State</label>
                                                            <ng-select [items]="stateList" 
                                                                [searchable]="true" [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation" >
                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>Zip code</label>
                                                            <input (ngModelChange)="validZip() " type="text"
                                                                class="form-control" minlength="5" maxlength="11"
                                                                (keypress)="keyPress($event)" disabled>
                                                            <span class="ssn1" *ngIf="zip6">{{ziperr}}</span>

                                                        </div>
                                                    </div>


                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="row mt-2">

                                                        <div class="col-lg-1">
                                                            <input type="radio"
                                                                (ngModelChange)="w4_fun_marriedheld($event) " id="m1"
                                                                name="mstatus" value="stats1" disabled>
                                                        </div>
                                                        <div class="col-lg-10">
                                                            <label>Single; Married, but legally separated; or
                                                                Spouse is a nonresident alien</label>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">

                                                        <div class="col-lg-1">
                                                            <input type="radio"
                                                                (ngModelChange)="w4_fun_marriedheld($event) " id="m2"
                                                                name="mstatus" value="stats2" disabled>
                                                        </div>
                                                        <div class="col-lg-10">
                                                            <label>Married</label>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">

                                                        <div class="col-lg-1">

                                                            <input type="radio"
                                                                (ngModelChange)="w4_fun_marriedheld($event) " id="m3"
                                                                name="mstatus" value="stats3" disabled>
                                                        </div>
                                                        <div class="col-lg-10">
                                                            <label>Married, but withhold at higher Single
                                                                rate</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2 ms-4">
                                <p><b>Complete Section 1 OR Section 2, then sign the bottom and give the
                                        completed form to your employer</b></p>
                            </div>



                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <div class="d-flex ms-lg-1">
                                                <input type="radio" (change)="sectionDetermine($event)" id="sec1" name="section"
                                                    value="false" [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances" >
                                                <!-- [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.exemption_minnesota_withholding" -->
                                                <h5 class="ms-1 pt-2"><b> Section 1 -</b>&nbsp;Determining Minnesota
                                                    Allowances</h5>
                                            </div>
                                        </div>
                                        <div class="card-body" style="padding:35px;">


                                            <div class="row mt-2" [formGroup]="Section1Form" >
                                                <ol style="margin-left: 10px;" type="A">
                                                    <li> Enter “1” if no one else can claim you as a dependent
                                                        ...................................&nbsp;&nbsp;A
                                                        &nbsp;&nbsp; <input type="text" class="form-control"
                                                            style="width: 180px;display: inline-block;" formControlName="input1"
                                                             [(ngModel)]="w4MinnesotaWithholdingBo.ifNoOneClaimyouasdependent">
                                                    </li>



                                                    <li> Enter “1” if any of the following apply:
                                                        .................................................&nbsp;&nbsp;B
                                                        &nbsp;&nbsp; <input type="text" class="form-control" formControlName="input2"
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.ifanyofFollowingApply" >
                                                    </li>
                                                    <ul style="margin-left: 30px;">
                                                        <li>You are single and have only one job</li>
                                                        <li>You are married, have only one job, and your spouse
                                                            does not work</li>

                                                        <li>Your wages from a second job or your spouse’s wages
                                                            are $1500 or less</li>
                                                    </ul>


                                                    <li>Enter “1” if you are married. Or choose to enter “0” if
                                                        you are married and have either a working
                                                        spouse or more than one job. (Entering “0” may help you
                                                        avoid having too little tax withheld.) . .&nbsp;&nbsp;C
                                                        &nbsp;&nbsp; <input type="text" class="form-control"  formControlName="input3"
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.haveeitherworkingSpouseormorethanOneJob" >
                                                    </li>
                                                    <li> Enter the number of dependents (other than your spouse
                                                        or yourself)
                                                        you will claim on your tax return.
                                                        ...................................................&nbsp;&nbsp;D
                                                        &nbsp;&nbsp; <input type="text" class="form-control"  formControlName="input4"
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.numberofdependents" >
                                                    </li>
                                                    <li>Enter “1” if you will use the filing status Head of
                                                        Household (see instructions).
                                                        ................&nbsp;&nbsp;E&nbsp;&nbsp; <input type="text" formControlName="input5"
                                                            class="form-control" 
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.filingstatusHeadofHousehold">
                                                    </li>

                                                    <li>Add steps A through E. If you plan to itemize deductions
                                                        on your 2022 Minnesota income tax
                                                        return, you may also complete the Itemized Deductions
                                                        and Additional Income Worksheet.
                                                        ..&nbsp;&nbsp;F&nbsp;&nbsp; <input type="text" formControlName="input6"
                                                            class="form-control" 
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.deductionsandAdditionalIncomeWorksheet"></li>

                                                </ol>
                                                <ol style="margin-left: 10px;" type="1">
                                                    <li>Minnesota Allowances. Enter Step F from Section 1 above
                                                        or Step 10 of the Itemized Deductions Worksheet
                                                        ...........&nbsp;&nbsp;1 &nbsp;&nbsp;$ <input type="text" formControlName="input7"
                                                            class="form-control"  
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.minnesotaAllwances"></li>
                                                    <li>Additional Minnesota withholding you want deducted for
                                                        each pay period (see instructions)
                                                        .........................&nbsp;&nbsp;2
                                                        &nbsp;&nbsp;$ <input type="text" class="form-control"  formControlName="input8"
                                                            style="width: 180px;display: inline-block;" [(ngModel)]="w4MinnesotaWithholdingBo.additionalMinnesotawithholding" >
                                                    </li>
                                                </ol>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- this. = val.target.checked -->
                            <!-- this.documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances = false -->

                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <div class="d-flex ms-lg-1">
                                                <input type="radio" (change)="sectionDetermine($event)" id="sec2" name="section"
                                                    value="true" [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances">
                                                <!-- section($event); 
                                   [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances"
    -->
                                                <h5 class="ms-1 pt-2"><b>Section 2</b>&nbsp;— Exemption From Minnesota
                                                    Withholding</h5>
                                            </div>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div [formGroup]="Section2Form" >
                                            <div class="row mt-2 ms-2">
                                                <p>Complete Section 2 if you claim to be exempt from Minnesota
                                                    income tax withholding (see Section 2 instructions for
                                                    qualifications). If applicable,
                                                    check one box below to indicate why you believe you are
                                                    exempt</p>
                                            </div>
                                            <div class="d-flex ms-2">
                                                <input type="radio" [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2" id="a" value="A" name="radiosection2"  [ngModelOptions]="{standalone: true}" (change)="option_section2($event)">&nbsp;&nbsp;<p>A&nbsp;&nbsp; I meet the
                                                    requirements and claim exempt from both federal and
                                                    Minnesota income tax withholding</p>
                                            </div>
                                            <div class="d-flex ms-2">
                                                <input type="radio" [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2" (change)="abc()" id="b" value="B" name="radiosection2" [ngModelOptions]="{standalone: true}" (change)="option_section2($event)">&nbsp;&nbsp;<p>B&nbsp;&nbsp;Even though I
                                                    did not claim exempt from federal withholding, I claim
                                                    exempt from Minnesota withholding, because:</p>
                                            </div>
                                            <ul style="margin-left:50px;" class= "mt-3">
                                                <li>I had no Minnesota income tax liability last year</li>
                                                <li>I received a refund of all Minnesota income tax withheld
                                                </li>
                                                <li>I expect to have no Minnesota income tax liability this year
                                                </li>


                                            </ul>
                                            <div class="d-flex ms-2">
                                                <input type="radio" [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2" (change)="option_section2($event)" name="radiosection2" [ngModelOptions]="{standalone: true}" id="c" value="C">&nbsp;&nbsp; <p>C&nbsp;&nbsp;All of these
                                                    apply:</p>
                                            </div>
                                            <ul style="margin-left:50px mt-3">
                                                <li>My spouse is a military service member assigned to a
                                                    military location in Minnesota</li>
                                                <li>My domicile (legal residence) is in another state</li>
                                                <li>I am in Minnesota solely to be with my spouse. My state of
                                                    domicile is&nbsp;&nbsp; <input type=" text" class="form-control"
                                                        style="width: 180px;display: inline-block;" formControlName="input1"
                                                         [(ngModel)]="w4MinnesotaWithholdingBo.state_domicile"  >
                                                </li>
                                            </ul>
                                            <div class="d-flex ms-2">
                                                <input type="radio" [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2" (change)="option_section2($event)" id="d" [ngModelOptions]="{standalone: true}" name="radiosection2" value="D">&nbsp;&nbsp;<P>D&nbsp;&nbsp;I am an
                                                    American Indian that resides and works on a reservation.
                                                </P>
                                            </div>
                                            <div class="row ms-4 mt-3">
                                                <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter the reservation
                                                    name&nbsp;&nbsp; <input type="text" class="form-control"
                                                        style="width: 180px;display: inline-block;" formControlName="input2"
                                                        [(ngModel)]="w4MinnesotaWithholdingBo.reservation_name"  >
                                                </p>
                                            </div>
                                            <div class="row ms-4">
                                                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter your Certificate of
                                                    Degree of Indian Blood (CDIB)/Enrollment
                                                    number&nbsp;&nbsp; <input type="text" class="form-control"
                                                        style="width: 180px;display: inline-block;" formControlName="input3"
                                                         [(ngModel)]="w4MinnesotaWithholdingBo.enroll_no" >
                                                </p>

                                            </div>

                                            <div class="row">

                                                <div class="col-12">
                                                    <p> <input (change)="option_section2($event)" name="radiosection2" [ngModelOptions]="{standalone: true}"
                                                            type="radio"  [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2" id="e" value="E">&nbsp;&nbsp;E&nbsp;&nbsp;I am a
                                                        member of the Minnesota National Guard or an active duty
                                                        U.S. military member and claim exempt from Minnesota
                                                        withholding
                                                        on my military pay</p>
                                                </div>

                                            </div>

                                            <div class="row">
                                                <div class="col-12">
                                                    <p> <input value="F" (change)="option_section2($event)" [ngModelOptions]="{standalone: true}" name="radiosection2" type="radio" id="f" [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2">
                                                        &nbsp;&nbsp;F&nbsp;&nbsp;I
                                                        receive a military pension or other military retirement
                                                        pay as calculated under U.S. Code, title 10, sections
                                                        1401 through 1414, 1447
                                                        through 1455, and 12733, and I claim exempt from
                                                        Minnesota withholding on this retirement pay</p>

                                                </div>

                                            </div>



                                            <div class="row mt-2">
                                                <p>I certify that all information provided in Section 1 OR
                                                    Section 2 is correct. I understand there is a $500 penalty
                                                    for filing a false Form W-4MN</p>
                                            </div>

                                            <div class="row mt-5 ms-2">
                                                <div class="col-lg-4">
                                                    <button type="button" class="btn btn-primary" data-toggle="modal"
                                                        data-target="#nur"  disabled>
                                                        Employee’s Signature
                                                    </button>

                                                </div>
                                                <div class="col-lg-1">
                                                    <label for="cname">Date:</label>
                                                </div>
                                                <div class="col-lg-2">
                                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                        placeholder="mm/dd/yyyy" [disabled]="true">
                                                    </my-date-picker>
                                                </div>
                                                <div class="col-lg-3 text-center">
                                                    <label>Daytime Phone Number</label>
                                                </div>
                                                <div class="col-lg-2">
                                                    <input type="text" class="form-control" minlength="14"
                                                        maxlength="14" 
                                                         [(ngModel)]="w4MinnesotaWithholdingBo.phoneNumber"
                                                         (keypress)="keyPress($event)" 
                                                         (ngModelChange)="DemographicPhoneFormat()" 
                                                         [ngModelOptions]="{standalone: true}"
                                                         disabled>
                                                </div>


                                            </div>

                                            <div class="row mt-2 mb-2">

                                                <div class="col-lg-4">
                                                    <input *ngIf="clientsign1!=''&& clientsign1!=null " type="image"
                                                        src="{{clientsign1}}" class="form-control"
                                                        style="width: 255px;height:120px;" alt="nurse" width="48"
                                                        height="48">
                                                </div>
                                            </div>


                                            <div class="row mt-2">
                                                <p>Employees: Give the completed form to your employer. </p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>Employers</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                See the employer instructions to determine if you must send a
                                                copy of this form to the Minnesota Department of Revenue. If
                                                required, enter your
                                                information below and mail this form to the address in the
                                                instructions. (Incomplete forms are considered invalid.) We may
                                                assess a $50 penalty for
                                                each required Form W-4MN not filed with us. Keep a copy for your
                                                records
                                            </div>

                                            <div class="row mt-2 mb-3">
                                                <div class="col">
                                                    <div class="card ">
                                                        <div class="card-body" style="padding:25px;">
                                                            <div class="row">
                                                                <div class="col-lg-12">
                                                                    <div class="row mt-2">
                                                                        <div class="col-4">
                                                                            <label>Name of Appointee</label>
                                                                            <input type="text" class="form-control" disabled>
                                                                        </div>
                                                                        <div class="col-4">
                                                                            <label>Minnesota Tax ID
                                                                                Number</label>

                                                                            <input type="text" class="form-control" [(ngModel)]="w4MinnesotaWithholdingBo.taxIdNumber"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            disabled >

                                                                        </div>
                                                                        <div class="col-4">
                                                                            <label>Federal Employer ID Number
                                                                                (FEIN)</label>

                                                                            <input type="text" class="form-control" [(ngModel)]="w4MinnesotaWithholdingBo.federal_Id_number" 
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            disabled/>

                                                                        </div>
                                                                    </div>

                                                                    <div class="row mt-2">
                                                                        <div class="col-5">
                                                                            <label>Address</label>

                                                                            <textarea class="form-control" disabled></textarea>


                                                                        </div>
                                                                        <div class="col-3">
                                                                            <label>City
                                                                            </label>
                                                                            <input type="text" class="form-control" disabled>
                                                                        </div>
                                                                        <div class="col-2" >
                                                                            <label>State</label>

                                                                            <ng-select [items]="stateList" 
                                                                                  [searchable]="true"
                                                                                [clearable]="true" bindLabel="name"
                                                                                bindValue="abbreviation" >
                                                                            </ng-select>
                                                                        </div>
                                                                        <div class="col-2">
                                                                            <label>Zip Code</label>
                                                                            <input (ngModelChange)="validZip() "
                                                                                type="text" minlength="5" maxlength="11"
                                                                                (keypress)="keyPress($event)"
                                                                                class="form-control" disabled>
                                                                            <span class="ssn1"
                                                                                *ngIf="zip7">{{ziperr}}</span>


                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                       </div> </div>
                                    </div>
                                </div>
                            </div>







                            <!-- </form> -->
                            <!-- documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.date -->

                        </div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden;
                                   
                                    height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-2">
                                <img src="..\assets\img\revenue.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <div class="row mt-4">
                                <p>Complete this form for your employer to calculate the amount of Minnesota
                                    income tax to be withheld from your pay.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>When should I complete Form W-4MN?</b></h5>
                            </div>
                            <ul style="margin-left:30px;">
                                <li>You begin employment</li>
                                <li>You Change your filing status</li>
                                <li>You reasonably expect to Change your filing status in the next calendar year
                                </li>
                                <li>Your personal or financial situation Changes</li>
                                <li>You claim exempt from Minnesota withholding (see Section 2 instructions for
                                    qualifications)</li>
                                <li> You receive distributions from an annuity or pension</li>
                            </ul>
                            <div class="row mt-2">
                                <p>If you have not had sufficient Minnesota income tax withheld from your wages,
                                    we may assess penalty and interest when you file your state
                                    income tax return</p>
                            </div>
                            <div c lass="row mt-2">
                                <p><b>Note:</b> Your employer may be required to submit a copy of your Form
                                    W-4MN to the Minnesota Department of Revenue. You may be subject to a
                                    $500 penalty if you provide a false Form W-4MN.</p>
                            </div>
                            <div class="row mt-2">
                                <p><b>You must enter your Social Security Number for this Form W-4MN to be
                                        valid. </b></p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I have completed federal Form W-4?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you completed a 2022 Form W-4, you must complete Form W-4MN to determine
                                    your Minnesota withholding allowances.</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you claim exempt from Minnesota withholding, complete only Section 2 of
                                    Form W-4MN and sign and date the form to validate it. If you
                                    complete Section 2, you must complete a new Form W-4MN by February 15 in
                                    each following year in which you claim an exemption from
                                    Minnesota withholding.</p>
                            </div>
                            <div class="row mt-2">
                                <p>You cannot claim exempt from withholding if all of these apply:</p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>
                                    Another person can claim you as a dependent on their federal tax return
                                </li>
                                <li>
                                    Your annual income exceeds $1,100
                                </li>
                                <li>
                                    Your annual income includes more than $350 of unearned income
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                    withholding. You will check the single box for marital status
                                    regardless of your actual marital status and may enter one personal
                                    allowance on Step A. Enter zero on steps B, C, and E.
                                    If you are resident of Canada, Mexico, South Korea, or India, and are
                                    allowed to claim dependents, you may enter the number of dependents on
                                    Step D.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                    withholding. You will check the single box for marital status
                                    regardless of your actual marital status and may enter one personal
                                    allowance on Step A. Enter zero on steps B, C, and E</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you are resident of Canada, Mexico, South Korea, or India, and are allowed
                                    to claim dependents, you may enter the number of dependents on
                                    Step D.</p>
                            </div>
                            <div class="row mt-2">
                                <h4><b>Section 1 — Minnesota Allowances Worksheet</b></h4>
                            </div>
                            <div class="row mt-2">
                                <p>Complete Section 1 to find your allowances for Minnesota withholding tax. For
                                    regular wages, withholding must be based on allowances you
                                    claimed and may not be a flat amount or percentage of wages.</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you expect to owe more income tax for the year than will be withheld, you
                                    can claim fewer allowances or request additional Minnesota
                                    withholding from your wages. Enter the amount of additional Minnesota income
                                    tax you want withheld on line 2 of Section 1.</p>
                            </div>
                            <div class="row mt-2">
                                <h4><b>Nonwage Income</b></h4>
                            </div>
                            <div class="row mt-2">
                                <p>Consider making estimated payments if you have a large amount of “nonwage
                                    income.” Nonwage income (other than tax-exempt income)
                                    includes interest, dividends, net rental income, unemployment compensation,
                                    gambling winnings, prizes and awards, hobby income, capital
                                    gains, royalties, and partnership income. </p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Two Earners or Multiple Jobs</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If your spouse works or you have more than one job, figure the total number
                                    of allowances you are entitled to claim on all jobs using
                                    worksheets from only one Form W-4MN. Usually, your withholding will be more
                                    accurate when all allowances are claimed on the Form
                                    W-4MN for the highest paying job and zero allowances are claimed on the
                                    others.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Head of Household Filing Status</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>You may claim Head of Household as your filing status if you are unmarried
                                    and pay more than 50% of the costs of keeping up a home for
                                    yourself, your dependents, and other qualifying individuals. Enter “1” on
                                    Step E if you may claim Head of Household as your filing status on
                                    your tax return. </p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I itemize deductions on my Minnesota return or have other nonwage
                                        income?</b></h5>
                            </div>



                            <div class="row mt-2">
                                <p>
                                    Use the Itemized Deductions and Additional Income Worksheet to find your
                                    Minnesota withholding allowances. Complete Section 1 on page 1,
                                    then follow the steps in the worksheet on the next page to find additional
                                    allowances
                                </p>
                            </div>
                            <div class="row mt-2 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-body" style="padding:25px;">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <p>1&nbsp;&nbsp;Enter an estimate of your 2022 Minnesota
                                                        itemized deductions. For 2022, you may have to reduce
                                                        your itemized deductions </p>
                                                    <p>if your income is over $206,050 ($103,025 for Married
                                                        Filing Separately). . . . . . . . <input type="number" min="0"
                                                            class="form-control" [(ngModel)]="w4MNInstructionsForEmployeesBo.estimate_Minnesota_ItemizedDeductions"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>2&nbsp;&nbsp;Enter one of the following based on your
                                                        filing status:. . . . . . . <input type="number" min="0"
                                                            class="form-control" [(ngModel)]="w4MNInstructionsForEmployeesBo.enterBasedOnFillingStatus"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>

                                                    <ul style="margin-left:30px">
                                                        <li>$25,800 if Married Filing Jointly</li>
                                                        <li>$19,400 if Head of Household</li>
                                                        <li> $12,900 if Single or Married Filing Separately</li>
                                                    </ul>
                                                    <p>3&nbsp;&nbsp;Subtract step 2 from step 1. If zero or
                                                        less, enter 0 . . . . . . . . <input type="number" min="0"
                                                            class="form-control" [(ngModel)]="w4MNInstructionsForEmployeesBo.subtractStep2FromStep1"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>4&nbsp;&nbsp;Enter an estimate of your 2022 additional
                                                        standard deduction (from page 11 of the Form M1
                                                        instructions). . . . . <input type="number" class="form-control"
                                                        [(ngModel)]="w4MNInstructionsForEmployeesBo.estimate_AdditionalStandardDeductions"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>5&nbsp;&nbsp;Add steps 3 and 4 . . . . . <input type="number"
                                                            class="form-control"   min="0" [(ngModel)]="w4MNInstructionsForEmployeesBo.addStep3AndStep4"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>6&nbsp;&nbsp;Enter an estimate of your 2022 taxable
                                                        nonwage income . . . . . . . <input type="number" min="0"
                                                            class="form-control" [(ngModel)]="w4MNInstructionsForEmployeesBo.estimateTaxableNonwageIncome"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>7&nbsp;&nbsp;Subtract step 6 from step 5. If zero, enter
                                                        0. If less than zero, enter the amount in parentheses. .
                                                        . . . . . . <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="w4MNInstructionsForEmployeesBo.subtractStep6FromStep5"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>8&nbsp;&nbsp;Divide the amount on step 7 by $4,450. If a
                                                        negative amount, enter in parentheses. Do not include
                                                        fractions . . . . . . <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="w4MNInstructionsForEmployeesBo.divideAmountOnStep7bySomeAmt"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>9&nbsp;&nbsp;Enter the number on step F of Section 1 on
                                                        page 1 . . . . . . . . <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="w4MNInstructionsForEmployeesBo.numberStepF"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>10&nbsp;&nbsp;Add step 8 and 9 and enter the total here.
                                                        If zero or less, enter 0. Enter this amount on line 1 of
                                                        page 1. . . . . . <input type="number" min="0" pattern="[0-9]" class="form-control"
                                                        [(ngModel)]="w4MNInstructionsForEmployeesBo.addStep8andStep9"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <h5><b>Section 2 — Minnesota Exemption</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Your employer will not withhold Minnesota taxes from your pay if you are
                                    exempt from Minnesota withholding. You cannot claim exempt
                                    from withholding if all of these apply:</p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>Another person can claim you as a dependent on their federal tax return</li>
                                <li>Your annual income exceeds $1,100</li>
                                <li>Your annual income includes more than $350 of unearned income</li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Box A</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Check box A of Section 2 to claim exempt if all of these apply:
                                </p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>You meet the requirements to be exempt from federal withholding</li>
                                <li>You had no Minnesota income tax liability in the prior year and received a
                                    full refund of Minnesota tax withheld</li>
                                <li>You expect to have no Minnesota income tax liability for the current year
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Box B</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Check box B of Section 2 if you are not claiming exempt from federal
                                    withholding, but meet the second and third requirements for box A.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Box C</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Check box C in Section 2 to claim exempt if all of these apply
                                </p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    You are the spouse of a military member assigned to duty in Minnesota
                                </li>
                                <li>
                                    You and your spouse are domiciled in another state
                                </li>
                                <li>
                                    You are in Minnesota solely to be with your active duty military spouse
                                    member
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Boxes D-G</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you receive income from the following sources, it is exempt from Minnesota
                                    withholding. Your employer will not withhold Minnesota tax
                                    from that income when you check the appropriate box in Section 2</p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    <b>Box D:</b> You receive wages as a member of an American Indian tribe
                                    living and working on the reservation of which you are an enrolled
                                    member. Enter the name of your reservation and your Certificate of Degree of
                                    Indian or Alaskan Blood (CDIB) number
                                </li>
                                <li>
                                    <b> Box E:</b> You receive wages for Minnesota National Guard (MNG) pay or
                                    for active duty U.S. military pay. MNG and active duty U.S.
                                    military members can claim exempt from Minnesota withholding on these wages,
                                    even if they are taxable federally. For more information,
                                    see Income Tax Fact Sheet 5, Military Personnel
                                </li>
                                <li>
                                    <b>Box F:</b>You receive a military pension or other military retirement pay
                                    calculated under U.S. Code title 10, sections 1401 through 1414, 1447
                                    through 1455, and 12733. You may claim exempt from Minnesota withholding on
                                    this income even if it is taxable federally
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <p><b>Note:</b> You may not want to claim exempt if you (or your spouse if
                                    filing a joint return) expect to have other forms of income subject to
                                    Minnesota tax and you want to avoid owing tax at the end of the year.
                                    If you complete Section 2, you must complete a new Form W-4MN by February 15
                                    in each following year</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you complete Section 2, you must complete a new Form W-4MN by February 15
                                    in each following year.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Nonresident Alien</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien for federal tax purposes, do not complete
                                    Section 2. </p>
                            </div>
                            <div class="row mt-2">
                                <h5>Line 2 — Additional Minnesota Withholding</h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you would like an additional amount of tax to be deducted per payment
                                    period, enter the amount on line 2. Do not enter a percentage of the
                                    payment you want to be deducted</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Use of Information</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>All information on Form W-4MN is private by state law. It cannot be given to
                                    others without your consent, except to the Internal Revenue Service,
                                    to other states that guarantee the same privacy, or by court order. Your
                                    name, address, and Social Security Number are required for identification.
                                    Information about your allowances is required to determine your correct tax.
                                    We ask for your phone number so we can call if we have a question.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Questions?</b></h5>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    Website: www.revenue.state.mn.us
                                </li>
                                <li>
                                    Email: withholding.tax@state.mn.us
                                </li>
                                <li>
                                    Phone: 651-282-9999 or 1-800-657-3594 (toll-free)
                                </li>
                            </ul>

                            <!-- </form> -->
                            <!-- <div class="col-12  mb-3 mt-1 row justify-content-end">
                                    <div class="me-2">
                                        <button class="btn text-end" >Clear</button>
                                    </div>
                                    <div class=" text-end">
                                        <button class="btn text-end" (click)="saveDocument()">Save</button>
                                    </div>
                                </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="row mb-2 mt-2">
                <div class="col">
                    <div class="card " style=" overflow-x:hidden; height:auto;">
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 text-center">
                                <h3><b>Form W-4MN Employer Instructions</b></h3>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Form W-4MN Requirement</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Federal Form W-4 will not determine withholding allowances used to determine
                                    the amount of Minnesota withholding. Employees completing a
                                    2022 Form W-4 will need to complete 2022 Form W-4MN to determine the
                                    appropriate amount of Minnesota withholding</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Lock-In Letters</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Internal Revenue Service (IRS) Letter 2800C tells you when the IRS believes
                                    your employee may have filed an incorrect federal Form W-4. If
                                    you receive this letter, you must provide the Minnesota Department of
                                    Revenue with a copy of the employee’s Form W-4MN. We will verify
                                    the number of allowances that the employee may claim for Minnesota purposes.
                                    Continue using the Form W-4MN you were using at the time
                                    you received Letter 2800C from the IRS, until we notify you to Change the
                                    amount of allowances on the employee’s Form W-4MN. If the
                                    employee has not completed a Form W-4MN, have them complete the form and use
                                    the allowances calculated on that form until notified by the
                                    department</p>
                            </div>
                            <div class="row mt-2">
                                <p><b>Use the amount on line 1 of page 1 for calculating the withholding tax for
                                        your employees.</b></p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>When does an employee complete Form W-4MN?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Employees complete Form W-4MN when they begin employment or when their
                                    personal or financial situation Changes</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>How should I determine Minnesota withholding for an employee that does
                                        not complete Form W-4MN?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If an employee does not complete Form W-4MN and they have a federal Form W-4
                                    (from 2019 or prior years) on file, use the allowances on
                                    their federal Form W-4. Otherwise, withhold Minnesota tax as if the employee
                                    is single with zero withholding allowances.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if my employee claims to be exempt from Minnesota withholding?</b>
                                </h5>
                            </div>
                            <div class="row mt-2">
                                <p>If your employee claims exempt from Minnesota withholding, they must complete
                                    Section 2 of Form W-4MN. They must provide you with a
                                    new Form W-4MN by February 15 of each year. If you are paying an employee
                                    for wages that are exempt from withholding, such as Medicaid
                                    Waiver Payments or wages to H-2A visa workers, do not send us Form W-4MN</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>When do I need to submit copies of a Form W-4MN to the department?</b>
                                </h5>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    When do I need to submit copies of a Form W-4MN to the department?
                                </p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>The employee claims more than 10 Minnesota withholding allowances</li>
                                <li>The employee checked box A or B under Section 2, and you reasonably expect
                                    the employee’s wages to exceed $200 per week</li>
                                <li>You believe the employee is not entitled to the number of allowances claimed
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <p>You do not need to submit Form W-4MN to us if the employee is asking to have
                                    additional Minnesota withholding deducted from their pay.
                                    We may assess a $50 penalty for each Form W-4MN you do not file with us when
                                    required.</p>








                            </div>
                            <div class="row">
                                <p>Mail Forms W-4MN to:</p>
                            </div>
                            <div class="row">
                                <p>Minnesota Department of Revenue </p>
                            </div>
                            <div class="row">
                                <p>600 N. Robert St</p>
                            </div>
                            <div class="row">
                                <p>St. Paul, MN 55146-6501</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if my employee is a resident of a state that has a reciprocity
                                        agreement with Minnesota?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If your employee is a resident of North Dakota or Michigan and they do not
                                    want you to withhold Minnesota tax from their wages, they must
                                    complete Form MWR, Reciprocity Exemption/Affidavit of Residency. They must
                                    complete a Form MWR by February 28 of each year, or within
                                    30 days after they begin working or Change their permanent residence. See
                                    Withholding Fact Sheet 20, Reciprocity - Employee Withholding, for
                                    more information. </p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What is an invalid Form W-4MN?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>A Form W-4MN is considered invalid if any of these apply:</p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>There is any unauthorized Change or addition to the form, including any
                                    Change to the language certifying the form is correct
                                </li>
                                <li>
                                    The employee indicates in any way the form is false by the date they provide
                                    you with the form
                                </li>
                                <li>The form is incomplete or lacks the necessary signatures</li>
                                <li>Both Section 1 and Section 2 were completed</li>
                                <li>The employer information is incomplete</li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>What if I receive an invalid form?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Do not use the invalid form to calculate Minnesota income tax withholding.
                                    Have the employee complete and submit a new Form W-4MN.
                                    If the employee does not give you a valid form, and you have an earlier Form
                                    W-4MN from them, use the earlier form to calculate their
                                    withholding</p>
                                <p>If a valid Form W-4MN is not completed by the employee, withhold taxes as if
                                    the employee is single and claiming zero withholding
                                    allowances</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if my employee is a nonresident alien of the United States?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If the wages to this employee are subject to income tax withholding, you will
                                    use Table 1 and the procedure under<b>Withholding Adjustment
                                        for Nonresident Alien Employees</b> in IRS Publication 15-T to determine
                                    the correct Minnesota withholding tax. Do not use this procedure
                                    for nonresident alien students from India and business apprentices from
                                    India. See IRS Notice 1392 for special instructions and withholding
                                    exceptions</p>
                            </div>
                            <!-- </form> -->

                            <!-- <div class="col-12  text-end">
                                <button class="btn"  (click)="saveDocument()">Save</button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="card-footer transparent bg-white">
            <div class="col-12 d-flex">
                 <button type="button" class="btn blue-btn" data-dismiss="modal">Close</button>
                  
                 <div class="col-6 text-end">
                    <button type="button" class="btn blue-btn" (click)="saveDocument()">
                        
                        Save</button>
                </div>
                 <button type="button" class="btn blue-btn" *ngIf="isUpdate "
                            (click)="saveDocument()">Save 
                        </button>
            </div>
        </div> -->
    </div>
</div>


<span id="NurseSign" data-toggle="modal" data-target="#nursesign"></span>
<div class="modal fade" id="nursesign" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" (click)="closeNurseSignModal()"></button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeNurseSignModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="nursesign" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="emp_signature" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_EMP [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_employer()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployee_sign1()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="emp_signature2" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_2 [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_employer_2()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="clearemployyesing3()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade" id="RZ" data-backdrop="static">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-header"> Sign</h5>
                    <button type="button" class="btn-close" data-dismiss="modal"> </button>
                </div>
                <div class="modal-body">
    
                    <div class="row">
                        <div class="col-lg-12">
    
                            <signature-pad #EnrollPad_2 [options]="signaturePadOptions"
                                (onEndEvent)="drawsign_employer_2()">
                            </signature-pad>
    
                        </div>
    
                    </div>
    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployee_sign3()">Clear</button>
                    <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div> -->
<div class="modal fade" id="app_signature" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_APP [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_applicant()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearApplicant_sign()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="i9FormModal" data-toggle="modal" data-target="#signature_employee"></span>
<div class="modal" tabindex="-1" role="dialog" id="signature_employee" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature employee</h5>
                <button type="button" class="btn-close"(click)="closeSignarueModal()" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #EmployeeSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteemployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployee_sign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeSignarueModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="BackModal1" data-toggle="modal" data-target="#background_modal1"></span>
<div class="modal" tabindex="-1" role="dialog" id="background_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature employee</h5>
                <button type="button" class="btn-close" (click)="closeBackModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #EnrollmentsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteEmployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployeeSignature()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal1()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="BackModal2" data-toggle="modal" data-target="#background_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="background_modal2" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Legal Guardian Signature (If employee is under the age of 18):</h5>
                <button type="button" class="btn-close" (click)="closeBackModal2()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #GurdiansignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteGurdiansign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearGurdianSignature()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="BackModal3" data-toggle="modal" data-target="#background_modal3"></span>

<div class="modal" tabindex="-1" role="dialog" id="background_modal3" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Legal Guardian Signature (If employee is under the age of 18):</h5>
                <button type="button" class="btn-close" (click)="closeBackModal3()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #GurdianPad [options]="signaturePadOptions" (onEndEvent)="drawGurdiansign()">
                        </signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearGurdianSignature1()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal3()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="DHS_4469AModal1" data-toggle="modal" data-target="#DHS_4469A_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="DHS_4469A_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">ORGANIZATION PERSONNEL SIGNATURE:</h5>
                <button type="button" class="btn-close" (click)="closeDHS_4469AModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #SupportworkerPad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompetesupportsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearsupportsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeDHS_4469AModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="DHS_4469AModal2" data-toggle="modal" data-target="#DHS_4469A_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="DHS_4469A_modal2" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Applicant Signature:</h5>
                <button type="button" class="btn-close" (click)="closeDHS_4469AModal2()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #SignatureIndividualPad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteindividualsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearindividualsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeDHS_4469AModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="Employee_GenModal1" data-toggle="modal" data-target="#Employee_Gen_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="Employee_Gen_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Employee/Applicant Signature</h5>
                <button type="button" class="btn-close"(click)="closeEmployeeGenModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #ApplicantsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteapplicantsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearApplicantsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeEmployeeGenModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="Employee_GenModal2" data-toggle="modal" data-target="#Employee_Gen_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="Employee_Gen_modal2" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of parent/Legal Guardian</h5>
                <button type="button" class="btn-close"(click)="closeEmployeeGenModal2()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #LegalsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompletelegalsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearLegalsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeEmployeeGenModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="FEA_EmpModal1" data-toggle="modal" data-target="#FEA_Emp_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="FEA_Emp_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Employee Signature</h5>
                <button type="button" class="btn-close" (click)="closeFEAModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #Pad [options]="signaturePadOptions" (onEndEvent)="sign1()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployeeSignature3()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeFEAModal1()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="ageModal1" data-toggle="modal" data-target="#agepage_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="agepage_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">SIGNATURE OF SUPPORT WORKER</h5>
                <button type="button" class="btn-close"(click)="closeageModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #ageRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteRepsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearRepsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeageModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="WageModal1" data-toggle="modal" data-target="#wagepage_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="wagepage_modal1" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Participant/Rep Signature</h5>
                <button type="button" class="btn-close" (click)="closeWageModal1()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #WageRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteRepemployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearRepemployeesign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeWageModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="TranslatorModal" data-toggle="modal" data-target="#traslatorModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="traslatorModal" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Preparer or Translator</h5>
                <button type="button" class="btn-close" (click)="closeTranslatorModal()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #TranslatorSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompetetranslatorsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="cleartranslatorsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeTranslatorModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="AuthorizedModal" data-toggle="modal" data-target="#authorizedModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="authorizedModal" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Employer or Authorized Representative</h5>
                <button type="button" class="btn-close" (click)="closeAuthorizedModal()" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #AuthorizedSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteauthorizedsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearauthorizedsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeAuthorizedModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="AuthorizedRepModal" data-toggle="modal" data-target="#authorizedRepModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="authorizedRepModal" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Employer or Authorized Representative</h5>
                <button type="button" class="btn-close" (click)="closeAuthorizedRepModal()" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #AuthorizedRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteauthorizedRepsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearauthorizedRepsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeAuthorizedRepModal()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="NurseSignModal" data-toggle="modal" data-target="#nursesignmodal"></span>
<div class="modal fade" id="nursesignmodal" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Employee Sign</h5>
                <button type="button" class="btn-close" (click)="closeNurseModal()"></button>
            </div>
            <div class="modal-body">

                <signature-pad #EmpSignPad [options]="signaturePadOptions" (onEndEvent)="drawCompleteEmpsign()">
                </signature-pad>

                <div class="row">
                    <div class="col-lg-12">



                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature1()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    (click)="closeNurseModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="nursesign" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="nurse" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad [options]="signaturePadOptions" (onEndEvent)="draw()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature4()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="epe" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad3 [options]="signaturePadOptions" (onEndEvent)="draw3()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature9()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="epr" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad4 [options]="signaturePadOptions" (onEndEvent)="draw4()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature0()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="applicant" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"> </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #appsignpad [options]="signaturePadOptions" (onEndEvent)="appsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearapp()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="parentsign" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"></button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #parentsignpad [options]="signaturePadOptions" (onEndEvent)="parentsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearparent2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="authsign" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"></button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #authsignpad [options]="signaturePadOptions" (onEndEvent)="parentsign1()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearparent()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="nur" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"></button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnPad [options]="signaturePadOptions" (onEndEvent)="create()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature5()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="deposit" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-dismiss="modal"></button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #depositPad [options]="signaturePadOptions" (onEndEvent)="create2()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature6()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>






  
   
